import { success } from '@assets/common'
import Locale from 'element-ui/lib/locale/lang/zh-CN.js' // 引入element语言包
const zh = {
  login: {
    name: '',
    page: '',
    lanuage: '请选择语言',
    text: '邮箱登录',
    text2: '验证码登录',
    email: '邮箱账号',
    placeholdername: '邮箱账号',
    placeholderemail: '请输入邮箱账号',
    emailformate: '邮箱格式错误',
    placeholderpsw: '密码',
    login: '登录',
    account: '记住邮箱',
    password: '记住密码',
    rememberPhone:'记住手机号',
    getCode: '获取验证码',
    register: '用户注册',
    passwords: '忘记密码',
    pswr: '请输入密码',
    emailr: '邮箱验证码',
    phone: '手机登陆',
    phoneplace: '手机号码',
    phoneerror: '手机号码格式错误',
    phoneverify: '手机验证码',
    countryTitle: '国家/地区',
    // tokenError: 'Token错误，或者登陆超时!',
    tokenError: '登陆超时!',
    accountDisabled: '帐号被禁用！',
    userNotActivated: '用户未激活！',
    userFrozen: '用户已冻结',
    tryAgain: '请稍后重试',
    validPhoneNumber: '请填写正确的手机号',
    simplifiedChinese: '简体中文',
  },
  sync: {
    overflow: '溢出',
    manle: `该设备内场景已满,无法参与场景【 $$ 】。如需参与新场景请先前往删除，删除后点击【重试】。`,
    data: '发起时间',
    areaname: '区域',
    time: '时间',
    identification: '识别',
    retry: '重试',
    delete: '删除',
    synchronizing: '同步中...',
    cousreTitle: '数据同步',
    background: '后台执行',
    allTry: '全部重试',
    info: '操作提示',
    alltry: '全部重试',
    close: '取消',
    area: '移动区域',
    scene: '场景',
    ifttt: '自动化',
    config: '参数配置',
    projectId: '项目号',
    constIllumination: '恒照度',
    rhythm: '日程',
  },
  sylogs: {
    dataControlTip: '仅展示3个月内的数据',
    dataControlTip1: '仅展示最近的50条数据,切换日期查看指定日期数据',
    infor: '信息',
    warning: '警告',
    error: '错误',
    to: '至',
    startdate: '开始日期',
    enddate: '结束日期',
    plhode2: '请选择级别',
    plhode3: '请输入名称',
    plhode4: '请输入EventID',
    plhode5: '请输入详情',
    search: '搜索',
    out: '导出',
    dates: '时间',
    lever: '级别',
    id: '设备云ID',
    name: '设备名称',
    EventID: 'EventID',
    detail: '详情',
    waring: '设备地址冲突',
    all: '全部',
    downfiletip: '下载文件生成中，请稍等',
    systemModuleName: '相关模块',
    userActionTypeName: '操作类型',
    urlPath: '接口路径',
    arguments: '请求参数',
    callResultCode: '返回',
    uCloudId: '云ID',
    ipAddress: '操作IP',
    success: '成功',
    fail: '失败',
    datapickerLimit: '导出最长时间跨度为1个月,请调整',
    allEvent: '全部事件',
  },
  failureLogs: {
    dates: '上报时间',
    id: '设备云ID',
    name: '设备名称',
    area: '所属区域',
    failure: '故障情况',
    operation: '操作',
    failureRemind: '故障提醒',
    time: '时间',
    go: '查看故障',
  },
  otaUpdate: {
    customTime: '升级任务自定义时间开始',
    notStarting: '手动执行',
    name: '设备名称',
    type: '设备类型',
    online: '在线',
    Update: '升级状态',
    caozuo: '操作',
    update: '升级',
    know: '识别',
    stop: '停止',
    tab1: '所有',
    tab2: '待升级',
    tab3: '升级中',
    tab4: '升级成功',
    tab5: '升级失败',
    offline: '离线',
    identification: '识别',
    upgrade: '升级',
    initiatefail: '发起升级失败',
    ingfail: '升级失败',
    success: '升级成功',
    warninginfor: '暂无可升级设备',
    waitForupgrade: '待升级',
    Upgradeing: '升级中',
    UpgradeSuccess: '成功',
    UpgradeDuplicate: '失败',
    UpgradeFail: '重复升级',
    UpgradeConfilct: '操作冲突',
    UpgradeBusy: '网关忙碌中，请稍后再试',
    UpgradeProjectIdNull: '没有项目编号',
    info: '操作提示',
    stopfail: '终止失败',
    stopsuccess: '终止成功',
    wakeUpDeviceAndUpgrade: '先按以下操作唤醒设备后，点击“立即升级”操作即可完成更新',
    webMeshOtaNotSupported: '当前蓝牙固件版本不支持 Web Mesh OTA，请使用 App GATT 升级',
    upgradeNow: '立即升级',
    automaticUpgrade: '静默升级',
  },
  addThirdDevice: {
    addgateway: '选择网关',
    span: '添加第三方设备',
    step1: '选择网关',
    step2: '选择COM串口',
    step3: 'COM对应的设备类型',
    save: '保存',
    back: '返回',
    productKey: '产品密钥',
  },
  addVirtualGateway: {
    next: '下一步',
    previous: '上一步',
    devicename: '设备名称',
    writedevicename: '请输入设备名称',
    span: '添加网关',
    step1: '1.选择网关类型',
    step2: '2.输入必要信息',
    header: '请选择网关类型',
    typewarning: '请选择网关类型',
    success: '添加成功！',
    error: '添加失败！',
    confiminfor: '设备已存在别的项目中,是否继续',
    notice: '提示',
    sure: '确定',
    back: '返回',
    cancle: '取消',
  },
  forgetpsw: {
    account: '邮箱账号',
    password: '密码',
    surepassword: '确认密码',
    emailr: '请输入邮箱验证码',
    yanzhneg: '邮箱验证码',
    placeholderemail: '请输入邮箱账号',
    placeholderpsw: '请输入密码',
    placeholderpswagain: '请再次输入密码',
    name: '智能照明系统',
    setnewpsw: '设置密码',
    setpsw: '找回密码',
    agree: '阅读并接受《用户隐私权保护声明》',
    ok: '完成',
    moredpsw: '请输入确认密码',
    passnosame: '两次密码输入保持一致',
    pswr2: '请输入6-15位数字和字母的组合',
    emailformate: '邮箱格式错误',
    userLive: '用户名已存在',
    userOff: '用户名不存在',
  },
  findGateway: {
    next: '下一步',
    previous: '上一步',
    devicename: '设备名称',
    suredevice: '确认设备',
    countdown: '倒计时',
    '120s': '请按照图示点击"确认"按钮,勾选完成后再点击“下一步”后将开启180s倒计时',
    g2Confirm: '请点击上图所示智能连接盒上的“Mesh”按钮，然后点击“下一步”。',
    mac: '网关MAC地址',
    macplaceholder: '请输入网关MAC地址',
    scanning: '扫描二维码',
    infor1: '恢复出厂设置及联网',
    infor2: '输入网关设备上的MAC地址',
    span: '添加网关',
    step1: '1.选择网关类型',
    step2: '2.看步骤图说明重置',
    step3: '3.输入必要信息',
    step4: '4.确认设备',
    step5: '5.查询设备',
    step6: '此时仍然可点击图示按键进行配网',
    header: '请选择网关类型',
    typewarning: '请选择网关类型',
    macwarning: '请输入网关MAC地址',
    success: '发现成功！',
    error: '发现失败！',
    confiminfor: '正在添加的网关已经在当前项目中，确认继续吗？',
    notice: '提示',
    sure: '确认',
    back: '返回',
    cancle: '取消',
    macerror: 'MAC地址长度有误，请检查',
    textHeader: '恢复出厂设置及联网',
    textOne: '先恢复出厂设置（如果确认已经恢复出厂设置可跳过此步），网关状态指示灯快闪，直到恢复出厂设置成功',
    textTwo: '按下侧面的重置按钮，即可重置网关。',
    textThree: '绿色的开/关图标将开始闪烁。',
    textfour: '按住不放，直到顶部三个图标都闪烁一次。这表示重置成功。',
    textfive: '静态IP,',
    textsix: '则通过：静态IP配 置方式完成配置后返回此页面',
    textseven: '网关需要正常的接入互联网（防火墙可能会限制），请确保所有三个LED指示灯都亮起。如需将网关列入白名单',
    texteight: 'WIFI,',
    texteight1: '联系IT',
    textnine: '',
    textnine1: '如果需要静态IP，请继续进行设置',
    textnine2: '静态IP',
    staticipsetcaption: '静态IP设置方法',
    staticipsetcaption1: '',
    staticipsetinfo: `用网线连接网关和电脑;/n配置电脑IP为192.168.1.x（x: 2~254），掩码255.255.255.0;/n如果网关固件版本低于V87.xx.xx，请开放TCP协议80、443端口及UDP协议65501端口用于升级。升级至V87.xx.xx版本后，通信协议将自动切换为TCP协议443端口(HTTPS)和8883端口(MQTT)。升级完成后，可关闭TCP协议80端口及UDP协议65501端口。/n打开浏览器输入192.168.1.1登入网关web页面;/n将IP Setting改为static 静态, 将IP Addr改为需要的IP地址，然后点 SAVE 保存;/n重启网关，配置生效。`,
    staticipsetinfo5: `蓝色标记的“静态 IP”一词指的是标准操作流程（SOP），就像当前在此步骤中的工作方式一样。/n请提前联系您的 IT 负责人，获取为 Smart Connect Box G2 准备的静态 IP 信息（IP 地址、子网掩码和默认网关）。/n使用以太网线将路由器的 LAN 端口直接连接到 Smart Connect Box。/n访问您的路由器管理页面（联系您的 IT 管理员获取访问详细信息），并利用其 MAC 地址找到对应的 Smart Connect Box IP 地址。/n打开浏览器，输入 https://[网关 IP] 登录智能照明 Web 系统。首次登录时，您需要设置登录密码。（如果您忘记密码，可以使用项目信息（包括项目代码、设备云 ID 和设备 MAC 地址）进行重置。或者，您也可以通过硬件重置将 Smart Connect Box G2 恢复为出厂设置。）/n在以太网配置中 ➔ 将 IP 设置从 DHCP 更改为静态 IP ➔ 填写所需的 IP 地址、子网掩码、网关（来自 IT 管理员）➔ 点击“保存”以保存更改；/n用针短按重置按钮以重启 Smart Connect Box G2。Smart Connect Box 现在将使用所设置的静态 IP 地址。`,
    staticipsetinfo6:`如果使用了防火墙或安全系统，请将每台 Smart Connect Box G2 的 MAC 地址提供给您的本地 IT 团队。您的本地 IT 团队会将这些 MAC 地址加入白名单，这也有助于防止将来出现连接问题。/n为确保 Smart Connect Box 稳定运行，请开放 TCP 端口 80、443（HTTPS）和 8883（MQTT）。如果您需要启用日志查询功能，则需要开放端口 80。同时，请确保能够访问域名 iotctrl1.opple.com，即 Smart Connect Box G2 所使用的云服务器。`,
    // staticipsetinfo: '用网线连接网关和电脑;/n配置电脑IP为192.168.1.x（x: 2~254），掩码255.255.255.0;/n让网关进入Bootloader程序; 蓝牙网关：长按功能按键15秒; 电源指示灯闪烁; OBUS及DALI网关：按住功能按键后，按重启按键; 状态指示灯闪烁;/n打开浏览器输入192.168.1.1登入网关web页面;/n将IP Setting改为static 静态, 将IP Addr改为需要的IP地址，然后点 SAVE 保存;/n重启网关，配置生效。',
    staticipsetinfo1: '',
    finishedDeviceCheck: '完成点击设备“确认”按钮',
    notAllowGateway: ' 暂不支持添加该网关',
    addOnApp: '请至APP上添加配置',
    deviceInfoError:'设备信息异常，请联系门店或欧普客服退换货处理 ',
    g2Tip1: '指示灯说明：①开关指示灯，②以太网指示灯，③云指示灯，④WiFi指示灯。',
    g2Tip2: '如果以太网指示灯不亮，请检查网线与路由器是否连接正常,',
    g2Tip3: '请联系IT',
    g2Tip4: '如果云状态指示灯不亮，请检查路由器是否可以访问 Internet，以及有线网络灯或 WiFi 指示灯是否正常点亮。',
    g2Tip5: '如需分配局域网',
    g2Tip9: '等待指示灯开关指示灯、以太网指示灯、云指示灯亮起后点击下一步。',
    g2Tip10: '长按图示复位键10秒以上恢复出厂设置，指示灯快速闪烁表示复位成功。',
    g2Tip11: '静态IP',
    g2Tip12: '才能正常连接网络,',
  },
  findDevice: {
    addgateway: '选择网关',
    span: '发现设备',
    step1: '选择网关',
    step2: '选择网络',
    step3: '启动扫描',
    step4: '停止扫描',
    child: '网络目录',
    progress: '加载进度:',
    save: '保存',
    back: '返回',
    warning: '请至少选择一个网络',
    finddevicetotal: '发现设备数量',
    countdown: '扫描倒计时:',
    area: '区:',
    areaNo: '区号',
    areaNoPlaceholder: '请输入区号',
    group: '组:',
    groupNo: '组号',
    gateway: '格兰斯贝网关',
    findDevice: '发现设备',
    moveAllDevice: '默认将所有设备移入本房间内，是否移入？',
    moveAllDeviceTip: '如暂不移入，可随后在无区域中再次操作。',
    notMoveIn: '暂不移入',
    moveIn: '移入',
    gatewayName: '请填写网关名称',
    selectDevice: '请选择设备',
    selectAll: '全选',
    remove: '移除',
  },
  register: {
    account: '邮箱账号',
    password: '密码',
    surepassword: '确认密码',
    name: '智能照明系统',
    placeholderemail: '请输入邮箱账号',
    emailformate: '邮箱格式错误',
    psw: '注册',
    regis: '用户注册',
    info: '（注册为安装人员）',
    address: '公司名称',
    phone: '联系电话',
    yanzhneg: '邮箱验证码',
    finsh: '完成',
    agreen: '阅读并接受#《用户隐私权保护声明》',
    placeholderpsw: '请输入密码',
    moredpsw: '请输入确认密码',
    emailr: '请输入邮箱验证码',
    pswr2: '请输入6-15位数字和字母的组合',
    phoneerror: '电话号码不规范',
    passnosame: '两次密码输入保持一致',
    checkmessage: '请接受《用户隐私权保护声明》',
    privacy: '隐私政策',
    declaration: '(1)为了使用Opple智能照明控制系统，用户必须使用公司电子邮件而不是个人电子邮件。<br> (2)Opple将仅收集用户公司的电子邮件，系统偏好和产品信息。不会存储任何用户的个人信息。<br> (3)Opple存储的信息仅用于确保正确的操作Opple智能照明控制系统。<br> (4)客户随时可以将Opple存储的信息完全删除。<br> (5)为了使用Opple智能照明控制系统，用户必须同意这一条款。<br>二. 如果用户通过“删除账号”功能删除其帐户，系统将删除所有与此帐户相关的信息。<br>对于条款（4）需要二作为补充',
    existingAccount: '已有账户?',
    countryempty: '国家/区域不能空',
  },
  header: {
    transProject: '移交项目',
    exit: '退出',
    projectname: '项目名称：',
    editmsg: '修改信息',
    restpsw: '重置密码',
    loginOut: '退出登录',
    save: '保存',
    cancel: '取消',
    language: 'ZN',
    oldpassword: '请输入旧密码',
    newpassword: '请输入新密码',
    confirmpassword: '请再次输入密码',
    username: '请输入用户姓名',
    useraddress: '请输入用户地址',
    userphone: '请输入电话号码',
    oldpasswarn: '老密码不能为空',
    newpasswarn: '新密码不能为空',
    twopasswarn: '两次密码不一致',
    dosending: '切换项目',
    switchProject: '切换项目',
    logOutUser: '删除账号',
    cancelUserTitle: '删除账号确认',
    cancelUserOneTips: '以上项目只有唯一的安装者，删除项目后项目不可恢复',
    cancelUserMoreTips: '为了您的账号安全，只有当您的账号下没有项目时才能删除账号，请将项目删除或移交他人后再操作',
    cancelUserOneDelTips: '项目只有唯一的安装者，删除项目后项目不可恢复.',
    cancelUserMoreDelTips: '删除项目后将无法继续访问该项目，确定删除当前所选的项目吗？',
    cancelUserOperOneMoreTips: '设备总数大于0的项目不可删除只能移交',
    selected: '已选择',
    project: '项',
    recipientEmail: '接收者邮箱',
    recipientEmailConfirm: '确认邮箱',
    cancelUser: '请确认是否要删除账号，删除账号后将无法登陆。',
    bindPhoneTitle: '绑定确认',
    unbindPhoneTitle: '解绑确认',
    bindPhoneTips: '绑定完成后，您可以使用该手机登录账号',
    unbindPhoneTips: '解绑以后，您将无法使用该手机登录账号',
    noBindPhoneTips: '未绑定手机号',
    noBindEmailTips: '未绑定邮箱号',
    bindPhoneOpareTips: 'Web端暂不支持手机号登录',
    transferEmail: '移交邮箱',
    recipientPhone: '接收者手机',
    recipientPhoneConfirm: '确认手机',
    setpsw: '设置密码',
    bindEmailTips: '绑定完成后，您可以使用该邮箱登录账号',
    unbindEmailTips: '解绑以后，您将无法使用该邮箱登录账号',
    transferPhone: '移交手机',
    helpTip: '您好，有什么可以帮助您？',
    helpDocument: '帮助文档',
    commonProblem: '常见问题',
    userGuide: '用户指引',
    problemType: '问题分类',
    submitter: '提交人',
    submitTime: '提交时间',
    emailFormatMismatch:'邮箱格式不一致',
    phoneNumberMismatch:'手机号码不一致',
  },
  sidebar: {
    home: '首页',
    details: '项目详情',
    projectDetails: '项目详情',
    management: '权限管理',
    install: '设备安装',
    monitoring: '监控',
    control: '照明控制',
    automation: '自动化',
    systemLog: '系统日志',
    failureList: '设备故障',
    ota: '在线升级',
    screen: '大屏幕',
    otatask: '升级任务',
    notices: '订阅通知',
  },
  devicelist: {
    treeplaceholder: '输入关键字进行过滤',
    warnmove: '相同区域无法移动',
  },
  projectList: {
    liteProjectTip: '无网关系统Lite',
    projectNum: '智能照明系统',
    add: '添加',
    projectApp: '无网关系统',
    openApp: '请在欧普智能照明APP中打开!',
    name: '项目名称',
    time: '创建时间',
    people: '安装者',
    state: '项目状态',
    num: '设备总数',
    address: '地点',
    UserRole: '用户角色',
    UserRole1: '超级管理员',
    UserRole2: '安装者',
    UserRole3: '管理员',
    UserRole4: '普通用户',
    UserRole5: '游客',
    caozuo: '操作',
    in: '进入',
    all: '归档',
    modify: '修改',
    accept: '接受',
    refuse: '拒绝',
    allcountry: '所有国家',
    normal: '正常',
    malfunction: '故障',
    activate: '激活',
    delete: '删除',
    good: '良好',
    serachWord: '请输入项目名称/关键词进行搜索',
    fireProject: '消防项目',
    comProject: '商照项目',
    standardProject: '标准项目',
    collection: '收藏',
    unCollection: '已收藏',
    continueConfiguring: '继续配置',
    notOperable: '标准项目配置中，不可操作',
  },
  projectmsg: {
    storeCode: '门店编码',
    StoreName: '门店名称',
    isNo: '项目IS号：',
    placeholder: '请输入',
    fillChannel: '请把回路数据填完整',
    channel: '通道',
    projectInfo: '华为云对接:',
    span1: '基本信息',
    span2: '详细信息',
    name: '项目名称：',
    type: '项目类型：',
    country: '所属国家：',
    time: '时区：',
    address: '项目地址：',
    img: '项目图片：',
    code: '邮政编码：',
    plhode0: '请输入项目名称',
    plhode1: '请选择项目类型',
    plhode2: '请选择国家/地区',
    plhode3: '请选择所属时区',
    plhode4: '请输入项目地址',
    plhode5: '请输入邮政编码',
    plhode6: '请选择项目属性',
    save: '保存',
    cancel: '取消',
    verificationName: '项目名称不能为空',
    verificationCountry: '请选择所属国家',
    verificationType: '请选择项目类型',
    verificationAttibute: '请选择项目属性',
    verificationTimeZone: '请选择时区',
    verificationWorkTime: '请选择工作时间',
    imginfo: '只能图片文件，且不超过2M',
    formateerror: '上传图片格式错误!',
    bigerror: '上传头像图片大小不能超过 2MB!',
    attribute: '项目属性：',
    ledEnergy: 'LED节能率：',
    ledEnergyTip: '请输入项目改造后LED节能率',
    everyWorkTime: '工作日工作时间：',
    workStartTime: '开始',
    workEndTime: '结束',
    span3: '国家信息',
    span4: '时区信息',
    DST: '夏令时：',
    DSTTime: '夏令时时间：',
    DSTTimeTips: '请选择夏令时时间',
    DSTTimeShift: '夏令时偏移：',
    DSTTimeShiftTips: '请选择夏令时偏移',
    DSTEnable: '启用',
    DSTDisable: '不启用',
    to: '-',
    startdate: '开始日期',
    enddate: '结束日期',
    month: '月',
    day: '日',
    countryModifyTips: '如果修改项目夏令时信息, 会同步该信息到设备, 请确认是否要修改?',
    timeModifyTips: '如果修改项目时区信息, 会同步该信息到设备, 请确认是否要修改?',
    modbusDocument: 'Modbus对接:',
    Meterdata: '电表数据：',
    ledEnergyError: 'LED节能率不能大于100',
    projectData: '项目数据:',
    exportIn: '导入数据包:',
    exportOut: '导出数据包:',
    uploadFile: '上传文件',
    downloadFile: '下载文件',
    fireProject: '消防',
    bacnetDocument: 'BACnet对接:',
    programList: '节目单:',
    errorFileTip: '格式错误，请重新导入文件',
    dataImfo: '数据信息',
    configured: '已配置',
    unconfigured: '未配置',
    holidaysConfiguration: '节假日配置',
    effectiveImmediately: '立即生效',
    configurationNote: '配置说明',
    holidaysConfigurationTip1: '点击空白日期即可配置为节假日;',
    holidaysConfigurationTip2: '点击“立即生效”后，所有自动化（含已建的自动化）中的节假日配置将被更新！',
    holidaysConfigurationTip3: '点击节假日即可切换为非节假日;',
    springFestival: '春节',
    tombSweepingDay: '清明节',
    laborDay: '劳动节',
    dragonBoatFestival: '端午节',
    midAutumnFestival: '中秋节',
    nationalDay: '国庆节',
    newYearsDay: '元旦',
    weekEnds: '周末',
    pleaseClickToConfigure: '请点击配置',
    anyPointInTime: '任意时间点',
    JSONOnly: '上传文件只能是JSON格式',
    fileNotExist: '文件不存在',
    fileReadFailed: '文件读取失败',
    jsonFormatError: 'JSON 格式错误，请检查文件内容',
    uploadValidJson: '请上传有效的 JSON 文件',
    resetStandardHolidays:'重置标准节假日',
    clearAll:'全部清空',
    confirmResetHoliday:'重置后已手动配置的节假日将被清空，是否继续？',
    confirmClearAll:'清空后节假日将全部被清除，是否继续？',
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',
    standardHoliday:'标准节假日',
    customizeHoliday:'自定义的节假日',
    useStandardHolidayNextYear: "下一年延用标准节假日",
    holidayUpdateSubscription: '节假日更新提醒订阅',
    enterEmailAddress: "请输入邮箱地址",
    invalidEmailFormat: "邮箱格式错误",
    fetchError: '暂无法获取节假日信息，请联系管理员',
    isAcknowledged: '我已知晓',
    countryChangeHoliday: '由于您已变更了国家信息，请及时更新并保存项目内的节假日信息，谢谢',
    pleaseSelectAtLeastOneHoliday: '请选择至少一个节假日',
    updatingTheCountry: '更新国家同时,是否直接更新时区信息',
    electricityPriceSettings: '电费设置',
    pleaseSelectType: '请选择类型',
    peakHours: '峰时',
    offPeakHours: '谷时',
    normalHours: '平时',
    others: '其他',
    electricityPrice: '电价',
    yuanPerKwh: '元/KWH',
    pleaseCompleteTimePeriodInfo: '请填写完整的时段信息',
    startTimeFormatInvalid: '开始时间格式必须为hh:mm，且不能是24:00',
    endTimeFormatInvalid: '结束时间格式必须为hh:mm',
    startEndTimeCannotBeSame: '开始时间和结束时间不能相同',
    invalidTimeFormat: '时间格式不正确，请使用hh:mm',
    invalidTimePeriod: '时段无效，请重新选择时间',
    timePeriodOverlap: '存在时段重叠，请调整时间',
    totalDurationExceeded: '总时长等于24小时',
    pleaseConfigureTieredPricing: '请配置阶梯电价',
    ratedPower: '额定功率(W)',
    powerDataConfiguration: '功率数据配置',
    constantLightIntensity: '恒光强',
    pleaseSetLatitudeLongitude: '请先到项目详情设置经纬度',
    playlistInformation: '节目单信息',
  },
  breadcrumb: {
    sy: '系统',
    home: '首页',
    Project: '项目列表',
    Archive: '归档列表',
    projectMsg: '项目信息',
    mangeUsers: '用户管理',
    addpeople: '添加被邀请人',
    systemlog: '设备日志',
    failureList: '设备故障',
    otaup: 'OTA升级',
    deviceinstall: '设备安装',
    scence: '场景',
    device: '设备',
    install: '设备安装 ',
    districtmange: ' 区域管理',
    devicemange: ' 设备管理',
    country: '筛选项目所属国家:',
    adddevice: '添加设备',
    addtruegateway: '添加网关',
    addvirtualdevice: '添加虚拟设备',
    findDevice: '发现设备',
    control: '照明控制',
    monitoring: '监控',
    ifttt: '自动化',
    iftttCustomSet: ' 自定义',
    templates: '模板',
    scenceMsg: '场景信息',
    operatelog: '操作日志',
    otaTask: '升级任务',
    duplicateArea: '复制区域',
    iftttCustomSetPanel: '面板自动化配置',
    mangeQrcode: '区域分享',
    addShare: '添加分享',
    mangeLimit: '权限管理',
  },
  user: {
    placeholdUserName: '请输入用户名',
    type1: '安装者/业主',
    type2: '管理者',
    type3: '普通用户',
    name: ' 用户名',
    phone: '电话 ',
    address: '单位 ',
    state: ' 状态',
    caozuo: ' 操作',
    add: '添加',
    sendemail: '再次邀请',
    limits: '权限范围',
    del: '删除',
    info: '提示',
    deltext: '删除不可恢复，是否确定删除？',
    cancel: '取 消',
    yes: '确 定',
    status: {
      0: '邀请中',
      1: '正常',
      2: '已拒绝',
      3: '删除中',
    },
    refuse: '你已拒绝邀请',
    addOne: '邀请#',
    editInfo: '账号信息编辑',
  },
  invite: {
    phoneInvite: '手机邀请',
    emailInvite: '邮箱邀请',
    phonerequired: '请输入被邀请人手机号码',
    phoneerror: '请输入正确的手机格式',
    enterEmailCN: '输入被邀请人邮箱或手机',
    inputPassword: '请输入初始密码',
    passwordAgain: '请再次输入密码',
    inviteOrCreate: '邀请/创建',
    createNewUser: '创建新用户',
    inviteSuccess: '邀请成功！',
    createSuccess: '创建成功！',
    loginNow: '被邀请人可用此账号直接登录!',
    span: '基本信息',
    yaoqing: '邀请',
    plhode1: '请输入被邀请人E-Mail',
    plhode2: '请输入被邀请人手机号',
    password: '请输入登录密码',
    span1: '发送成功',
    span2: '请提醒被邀请人尽快查收!',
    span3: '返回',
    enterEmail: '输入被邀请人邮箱',
    enterLimite: '设置被邀请人权限',
    limiteBlock: '区域权限',
    finsh: '完成',
    emailerror: '请输入正确的邮箱格式',
    emailrequired: '请输入被邀请人E-mail',
    passwordMismatch: '两次输入密码不一致',
  },
  monitor: {
    clickUpdate: '点击上传',
    dapingSetting: '设置',
    nameSetting: '名称设置',
    backgroundSetting: '背景设置',
    serverInfo: '服务器信息',
    haveUsed: '已使用',
    free: '空闲',
    cpuDetail: 'CPU信息',
    memoryDetail: '内存信息',
    diskDetail: '磁盘信息',
    cpuUsedInfo: 'CPU实时占用情况',
    memoryUsedInfo: '内存实时占用情况',
    showArea: '展示区域',
    showTime: '统计时间',
    DefaultAreaRank: '默认区域排行',
    customSettingRank: '自定义区域排行榜',
    rankingTitle1: '一级区域排行',
    rankingTitle2: '二级区域排行',
    rankingTitle3: '三级区域排行',
    rankingTitle4: '四级区域排行',
    saveEnergyRank: '节能排行榜',
    useEnergyRank: '能耗排行榜',
    showMore: '展示更多',
    curentDay: '当日',
    curentWeek: '当周',
    curentMonth: '当月',
    curentYear: '今年',
    curentSeason: '本季度',
    comfort: '舒适度',
    offline: '离线',
    online: '在线',
    open: '开灯',
    close: '关灯',
    error: '故障',
    allcount: '总数',
    lampcount: '灯具总数',
    canup: '可升级',
    select: '选择设备',
    allpower: '项目总能耗',
    allcomfort: '环境舒适度',
    importup: '导出',
    realtimepowerconsumption: '能源消耗',
    comparisonofregions: '各区域能耗对比',
    selectarea: '选择区域',
    agriAreaSelect: '区域选择',
    agriSensorTitle: '光照传感器',
    agriSensorNatural: '自然光照传感器',
    agriSensorUnderLamp: '灯下传感器',
    agriNoDataPlease: '暂无数据，请',
    agriPositionOutside: '大棚外',
    agriPositionRoof: '棚顶',
    agriPositionUnderLamp: '灯下',
    agriBindSensor: '绑定传感器',
    agriRebindSensor: '修改绑定',
    agriUnbindSensor: '解绑传感器',
    agriLightStatistics: '光照统计',
    agriLampBrightness: '灯具亮度',
    agriTodayNaturalLight: '今日自然光累计',
    agriTodayArtificialLight: '今日人工光累计',
    agriSupplementDuration: '补光时长',
    agriTargetProgress: '目标进度',
    agriDliTotal: '今日光照合计 (DLI)',
    agriDliNatural: '自然光',
    agriDliArtificial: '人工补光',
    agriSensorNaturalValueLabel: '当前光照值',
    agriSensorUnderLampValueLabel: '瞬时 PAR',
    agriToday: '今日',
    agriYesterday: '昨日',
    agriLastThreeDays: '最近三天',
    agriLastMonth: '上月',
    agriLastThreeMonths: '最近三月',
    agriChartNaturalDLI: '自然光累计',
    agriChartArtificialDLI: '人工光累计',
    agriChartTotalDLI: '光照合计',
    agriExportLightRecords: '灯具运行记录',
    agriExportSensorReport: '区域绑定农业传感器数据',
    agriExportSelectArea: '请先选择区域',
    agriExporting: '正在导出，请稍候…',
    hotspacepic: '空间利用率',
    ranking: '空间利用率排名',
    utilizationrate: '利用率:有人时长/总时长',
    devicestatus: '设备状态',
    sure: '确 定',
    cancle: '取 消',
    selectdevicearea: '设备区域选择',
    lasthour: '过去24小时',
    lastweek: '过去一周',
    lastmonth: '过去一个月',
    lastyear: '过去一年',
    realtime: '实时',
    onehour: '小时',
    warning1: '请至少选择一个区域',
    warning2: '选择的区域不能大于5个',
    warning3: '请选择设备状态',
    warning4: '选择的区域不能大于10个',
    warning5: '至少选择两个区域',
    areapowerline: '各区域能耗曲线',
    time: '',
    spacehottotal: '空间利用率',
    haveperson: '有人',
    noperson: '无人',
    areazline: '区域能耗柱形图',
    powername: '能耗',
    nodata: '暂无数据',
    nh: '能耗',
    hotvalue: '利用率',
    occupancyActiveButton: '激活区域动静分析',
    faultDevice: '故障报警设备',
    systemState: '系统状态',
    systemNormal: '正常',
    systemDeploy: '配置中',
    systemUnusual: '异常',
    systemDeployTips: '设备未完成同步系统配置数据',
    systemUnusualTips: '有故障设备等其他问题',
    choose: '请选择',
    realityEnergy: '实际能耗',
    realityEnergy1: '实际能耗',
    todayEnergy: '今日能耗',
    designEnergy: '设计能耗',
    savingEnergy: '节约能耗',
    maxEnergy: '最高能耗',
    minEnergy: '最低能耗',
    avgEnergy: '平均能耗',
    ledEnergy: 'LED节能',
    smartEnergy: '智能节能',
    ledEnergyRate: 'LED节能率',
    smartEnergyRate: '智能节能率',
    totalData: '总数据',
    changeEnergy: '变化',
    designEnergyTips: '设计能耗: ∑ⁿ( 单个灯具开灯时长 × 单个灯具最大功率 )。',
    smartEnergyTips: '智能节能率: （ 设计能耗 － 实际能耗 ) ÷ 设计能耗。',
    ledEnergyTips: 'Led节能率: ( 原灯具总功率 － 新灯具总功率 ) ÷ 原灯具总功率。',
    sArea: '移动区域',
    sConfig: '设备配置',
    sConstillumination: '恒照度配置',
    sIFttt: '自动化配置',
    sProject: '项目号',
    sRhythm: '日程配置',
    sScene: '场景配置',
    systemTitle: '欧普智能商照监控平台',
    projectname: '项目名称',
    projTodayTotalEnergy: '项目今日总能耗',
    dateButtonTxt: '请选择相邻的2-48小时',
    dateButtonTxt1: '请选择相邻的2-90天',
    dateButtonTxt2: '请选择相邻的2-60个月',
    dateButtonTxt3: '请选择相邻的2-30年',
    areaname: '区域',
    areaChoose: '可选择2-10个区域对比',
    areaContrast: '区域能耗对比',
    hour: '小时',
    day: '日',
    month: '月',
    year: '年',
    configYear: '年',
    configMonth: '月',
    configDay: '日',
    week: '周',
    energyAll: '总能耗',
    accounted: '占比',
    energyRate: '节能率',
    designTotalEnergy: '设计总能耗',
    realityTotalEnergy: '实际总能耗',
    week1: 'Monday',
    week2: 'Tuesday',
    week3: 'Wednesday',
    week4: 'Thursday',
    week5: 'Friday',
    week6: 'Saturday',
    week7: 'Sunday',
    January: '一月',
    February: '二月',
    March: '三月',
    April: '四月',
    May: '五月',
    June: '六月',
    July: '七月',
    August: '八月',
    September: '九月',
    October: '十月',
    November: '十一月',
    December: '十二月',
    exportConfirm: '确定导出',
    enterLimits: '请输入所有限额',
    gpNoNotempty: 'GpNo不能为空',
    selectAreaName: '选择区域名称',
    shangHai: '上海',
    beiJing: '北京',
    guangZhou: '广州',
    noAreaPermission:'由于您不具备区域权限导致无法完成配置，请联系管理员添加相应权限'

  },
  monitorMap: {
    deviceDetail: '设备详情',
    childDeviceRelation: '子设备拓扑',
    entryIconMonitorMapTip: '点击地图icon切换到地图监控',
    entryIconMonitorListTip: '点击列表icon切换到当前监控',
    equipmentOverview: '设备概况',
    energyManage: '能源管理',
    spaceUtilization: '空间利用率',
    openOrClose: '开启/关闭',
    onlineCount: '在线数',
    offlineCount: '离线数',
    alarm: '告警',
    spaceUtilizationShow: '空间利用率展示',
    spaceUtilizationRank: '空间利用率排名',
    percentageRankDesc: '按百分比降序排列',
    spaceMotionShow: '空间占用展示',
    spaceMotionDetail: '空间占用详情',
    collapse: '收起',
    motionAreaRank: '有人-无人区域排序',
    switchSpaceUtilizationSuccess: '地图展示模式已切换成空间利用率！',
    switchSpaceMotionSuccess: '地图展示模式已切换成空间占用！',
    totalDay: '今日累计',
    totalMonth: '本月累计',
    totalYear: '今年累计',
    noBindArea: '本区域还未绑定，请先在地图中绘制区域范围 并绑定本区域',
    noCurrentImg: '本区域不在当前图纸中，请切换至图纸',
    min: '最小',
    max: '最大',
    quarterStart: '开始季度',
    quarterEnd: '结束季度',
  },
  baoliMap: {
    projectBoard: '项目综合仪表盘',
    mapMode: '地图模式',
    listMode: '列表模式',
    defaultSort: '默认排序',
    warnNumber: '告警数',
    timeEnergy: '实时能耗',
    lightNumber: '亮灯数',
    today: '今日',
    nowYear: '今年',
    LightingRate: '亮灯率统计',
    entryProject: '进入项目',
    energyConsumption: '能耗统计',
    deviceNumber: '设备数量',
  },
  limite: {
    choose: '权限范围',
    finsh: '完成',
    Functional: '功能权限',
    index: '首页',
    project: '项目详情',
    monitoring: '监控(数据源修改)',
    lighting: '照明控制',
    areaLimit: '区域权限',
    movename: '目标区域',
    onewarn: '请至少选择一个区域',
    ifttt: '自动化',
    qrcode: '二维码',
    install: '设备安装',
    failureList: '设备故障',
    waring: '可对设备进行添加、删除、移动、替换等操作。',
    waring1: '您将给#角色赋予设备管理能力？',

    ok: '确定',
    cancel: '取消',
  },
  adddevice: {
    maintenance: '设备能力维护中，请稍后再试！',
    add: '添加设备',
    back: '返回',
    move: '移动',
    addto: '添加',
    realdevice: '设备',
    realgateway: '网关',
    virtualthirdparty: '虚拟第三方',
    virtualdevice: '虚拟设备',
    virtualgateway: '虚拟网关',
    realthirdparty: '第三方',
    ethernet: '以太网设备',
    findQcode: '找到面板背面的二维码',
    teleQcode: '使用手机扫描二维码得到80位字符串',
    example: '例如',
    enoceanInfo: '其中红色部分为本设备Mac地址，绿色部分为中继密钥',
    copyInsert: '将80位字符串整体复制到电脑中 填入对应的位置',
    selectDeviceType: '选择设备类型',
    enterDeviceName: '输入设备名称查询',
    MacAddress: 'Mac地址&密钥',
    findString: '如何查找字符串？',
    qcString: '请输入产品二维码对应的字符串',
    retry: '重新选择',
    configure: '去配置',
    failDevice: '有1个设备添加失败，请检查字符串是否正确',
    successDevice: '为了保证该设备的正常使用 需要选择灯具作为中继节点，请先去设备详情页配置',
    midConfig: '中继配置',
    secret: '密钥',
    noDevice: '暂无设备',
    requires32characters: '需要32个字符',
    moveTitle: '默认将所有设备移入本房间内，是否移入？如暂不移入，可随后在无区域中再次操作。',
    movebnt1: '暂不移入',
    movebnt2: '移入',
    addMaxDeviceTitle: '最多支持添加{{max}}个设备',
    noDeviceTitle: '暂无可作为代理节点的设备或者有可支持的代理节点设备但是版本过低需升级',
    noAddTitle: '暂无支持的网关或当前网关版本过低， 需要升级',
    addSuccess: '设备添加成功',
    outRang: '超出范围',
    least: '最少',
    upTo: '最多',
    subDevice:'网关子设备',
    tianmu:'天幕'
  },
  courseDataySync: {
    current: '本次操作',
    history: '当前配置数量',
    title: '数据同步',
    error: '当前故障数量',
    tipInfo: '默认将设备移入本房间内，是否确定？',
    reset: '复位',
  },
  tree: {
    exportExcel: '导入EXCEL区域树',
    downloadTemplate: '下载模板',
    excelInfo: '若未编辑Excel区域树，请下载模板并按模板格式编辑',
    excelTemplateName: '区域树标准模板',
    uploadTemplate: '上传EXCEL文件',
    uploadType: '仅支持.xlsx和.xls文件格式',
    moveHere: '拖拽替换文件至此处',
    title: '可控制节点',
    replaceExcel: '替换文件',
    uploadTime: '上传时间',
    plhode1: '输入关键字进行过滤',
    updatewaring: '有正在编辑或添加的选项未完成',
    city: '区域',
    placeholdertree: '输入名称查询区域',
    submit: '确定',
    cancle: '取消',
    delmsg: '确认要删除此项吗？',
    addmsg: '不能为空',
    treeMenuShowTip: '树型区域折叠',
    selfArea: '本区域',
    subArea: '子区域',
    nopermission: '无所选区域权限，无法展示区域信息，如有需要请联系管理员添加权限'
  },
  scene: {
    singleDeviceOne: '单设备场景最多只能选择1个',
    singleDevice: '单设备场景',
    onlyQuerySingle: '单设备场景',
    queryNonSingle: '区域场景',
    allScenarios: '全部场景',
    sceneNo: '场景号',
    masterControl: '总控',
    partialControl: '分控',
    tianmuNoGo: '天幕设备场景不可编辑',
    noFade: '不渐变',
    question: 'DALI设备不支持场景渐变时长',
    deviceTypes: '请选择设备协议类型',
    bluetooth: '蓝牙',
    converter: 'BLE-DALI 转换器',
    sceneSelect: '场景选择',
    searchPlhode1: '请输入场景名称或关键字',
    lastScene: '最后一次执行场景',
    lastSceneTime: '执行时间',
    lastSceneNone: '暂无执行场景',
    title: '场景',
    plhode2: '输入名称或Mac地址',
    plhode1: '请输入场景名称',
    add: '新增',
    adddevice: '添加设备',
    caozuo: '操作',
    remove: '移动',
    del: '删除',
    dele: '删除',
    power: '设置灯具最大功率',
    cancel: '取消',
    all: '全不选',
    allno: '全选',
    powerinfo: '设置该设备最大功率为',
    yes: '确 定',
    state: '状态：',
    block: '区域：',
    go: '执行',
    deltext: '是否确认删除',
    ok: '确定',
    control: '统一控制',
    controlsingle: '控制',
    device: '设备',
    gateway: '网关',
    deviceSelect: '设备选择',
    selectScence: '请至少选择一个场景',
    blockSelect: '区域选择',
    roomwarn: '在房间才可以操作',
    areawarn: '在区域才可以操作',
    powerOnInitState: '设置上电状态',
    lampGradual: '设置灯具渐变开关及时长',
    lampLinkagePanel: '设置灯具联动面板',
    sensorExtTime: '设置传感器延时时间',
    powerOnInitStateInfo: '设置该设备亮度值为',
    lampGradualSwitchInfo: '设置灯具渐变开关为',
    lampGradualExtimeInfo: '设置灯具渐变时长为',
    sensorExtTimeInfo: '设置传感器延时时间为',
    blockSelectLimitTips: '提示：当前最多只可选择#5#个区域!',
    blockOneSelect: '单个区域选择',
    blockMoreSelect: '更多区域选择',
    gatewayDeleTip: '删除的设备中含有网关，网关删除后，此网关下的设备也会被删除',
    batchResetInfo: '设置复位模式为',
    batchResetTypeNormal: '正常模式',
    batchResetTypeExpert: '专业模式',
    batchReset: '设置批量复位',
    batchConfigurePowerOnState: '配置上电状态',
    PowerOnState: '上电状态',
    PowerOnStatePrecious: '上次状态',
    PowerOnStateFixed: '固定状态',
    open: '打开',
    close: '关闭',
    selectSceneToCopy: '选择要复制的场景',
    lightCount: '灯片数',
    areaMapping: '请先配置区域映射，再执行场景',
    goConfig: '去配置',
    projectConfig: '项目配置',
    batchConfig: '批量配置',
    batchCLO: '批量CLO照度维护系数',
    DaliSulv: '设置DALI渐变速率',
    batchCLOTips: 'CLO照度维护系数',
    setBatchCLO: '设置CLO照度维护系数',
    NoFadeSupport: '以下设备不支持【 渐变时长 】功能，请修改渐变时长为默认设置',
    FadeSupportAfterUpgrade: '以下设备升级后支持渐变时长功能',
    WebImageScene: 'web图片场景',
    defaultFadeByScene: '默认状态跟随场景配置中的设备渐变时长',
    fadeTime: '渐变时长',
    sensorSensitive: '设置传感器灵敏度',
    sensitivity: '灵敏度',
    batchRename: '批量修改通道名称',
    LevelPerSecond: '{num} 级/秒',
   },
  tianmu: {
    minutes: '分钟',
    onlyOneTime: '天幕设备只能选择1个',
    devicePlaying: '设备播放中...',
    paused: '已暂停',
    times: '倍',
    onlyFiveVedio: '仅支持5条视频，如需继续上传，请先删除其它视频',
    noSolution: '没有找到方案',
    noDownloadedVideo: '暂无已下载的视频，无法继续播放',
    estimate: '预估',
    clickToRetry: '点击重试',
    static: '静态',
    dynamic: '动态',
    noVideo: '没有选择视频场景',
    customEditing: '自定义编辑',
    equipmentSchematic: '设备示意图',
    schemeAccepted: '方案接受',
    chooseNumber: '$$选1',
    multipleChoice: '多选一',
    master2: '二',
    master3: '三',
    master4: '四',
    master5: '五',
    notSupported: '不支持',
    maxSizeUniform: '尺寸最多为 {max}m',
    maxSizeSides: '需满足：一边 ≤ {maxLong}m，另一边 ≤ {maxShort}m',
    minSizeUniform: '尺寸最少为 {min}m',
    minSizeLampSides: '需满足：一边 ≥ {minLong}m，另一边 ≥ {minShort}m',
    circle: '圆形',
    radius: '半径',
    irregular: '异形',
    moduleMatch: '模组匹配',
    launchDate: '上市日期',
    shapeSelection: '形状选择',
    sdlModule: 'SDL 模块',
    sdlModuleSingle: '按单模块（75*75mm）',
    sdlModuleCombo: '自动匹配更优拼接方式（75*75mm、100*600mm、600*600mm）',
    lampModule: '灯具模组',
    lineModule: '线模组',
    faceModuleTooltip: '一体化设计，可整体铺装于墙面、天花、地面等大面积区域',
    lampModuleTooltip: '专为多元空间照明需求打造，支持单模块独立安装与多单元自由拼接，可灵活适配墙面、天花、地面等不同区域安装',
    lineModuleTooltip: '兼具实用性与设计感，精准匹配办公廊道、酒店线条装饰、零售门店边框照明、公共空间导视照明等多元线性场景，轻松打造简洁大气、富有延伸感的线性光影效果',
    uploadDrawing: '上传图纸',
    windowShadow: '有窗影',
    noWindowShadow: '无窗影',
    singleOffset: '单偏',
    doubleOffset: '双偏',
    directDown: '直下',
    lockedConfiguration: '已绑定方案',
    ceilingCurtainDevice: '天幕灯',
    Row: '行',
    Column: '列',
    layout: '排列',
    mainDevice: '主机',
    slaveDevice: '从机',
    testDescribe: '测试描述',
    InstallationDiagram: '安装与接线示意图',
    power: '电源',
    square: '矩形',
    ceilingCurtain: '天幕灯配置',
    lineDir: '走线方向',
    lightSources: '相邻两条光源间距',
    lightSourceDistribution: '光源分布',
    lineMap: '整体走线图',
    a3Info: '如需打印图纸，建议使用A3尺寸，彩色打印',
    constructionDepth: '施工深度',
    solutionModuleInvalid: '当前长宽已超出该模组适配范围，',
    solutionModuleMinInvalid: '当前长宽已低于该模组适配范围，',
    realPhotoProduct: '实拍产品规格',
    realPhoto: '实拍效果',
    thicknessDeep: '厚度(槽深)',
    specifications: '规格信息',
    exportsing: '正在导出中,时间较长，请耐心等待',
    installation: '安装要求',
    canvasInfo1: 'SDL光源按图纸要求均匀排布，相邻两条光源间距',
    canvasInfo2: '天幕槽内要求用木板搭成且涂成白色，槽深需>=$$mm，槽内需做好防尘处理，不能有多余孔或缝隙等；',
    canvasInfo3: '放置驱动及控制器检修口需靠近天幕，预留电源线;',
    canvasInfo4: '驱动到光学模组距离不超过5米，线缆需1.0平方及以上;',
    canvasInfo5: '当单条回路像素点大于80，建议增加首尾补电。',
    designerTools: '设计师工具',
    skyCeilingDesign: '天幕设计',
    pointPreview: '点位预览',
    faceModule: '面模组',
    workbenchZoomDrawing: '缩放图纸',
    workbenchFilmLimit: '膜限制',
    workbenchFilmLimitValue: '4.2m',
    myDesigns: '我的设计',
    createNewDesign: '新建设计',
    share: '分享',
    viewDetails: '查看详情',
    designName: '方案名称',
    placeholderDesignName: '请输入方案名称',
    createShape: '创建形状',
    specSettings: '规格设置',
    width: '长度',
    thicknessSlotDepth: '厚度（槽深）',
    maintenanceHatchPosition: '检修口位置',
    systemSettings: '系统设置',
    systemRecommend: '系统推荐',
    shortSide: '短侧边',
    longSide: '长侧边',
    effectPreview: '效果预览',
    maintenanceHatch: '检修口',
    lightDensity: '光源密度',
    selectControllerType: '选择控制器类型',
    singleChannelController: '单路控制器',
    dualChannelController: '双路控制器',
    previewSceneLibrary: '预览场景库',
    export: '导出',
    lightSourceInfo: '光源信息',
    billOfMaterials: '物料清单',
    lightDistributionDrawing: '光源分布图纸',
    view: '查看',
    area: '面积',
    lightingBlockchainCount: '发光区块链数量',
    controllerCount: '控制器数量',
    powerSupplyCount: '电源数量',
    maxPower: '最大功率',
    productName: '品名',
    partNumber: '料号',
    description: '描述',
    quantity: '数量',
    inputSpec: '输入规格',
    generateSolution: '生成方案',
    previousStep: '上一步',
    complete: '完成',
    nextStep: '下一步',
    exit: '退出',
    bluetooth:'蓝牙',
    imagesOnly:'仅支持图片场景',
    imagesAndVideosOnly:'支持图片与视频场景',
    canopyMaxLengthNotice:'单块天幕支持最大长度15m，超过15m将被分割',
    canopyMaxWidthNotice:'单块天幕支持最大宽度4.2m，超过4.2m将被分割',
    maintenancePortInstruction:'系统将自动推荐最佳位置',
    lightDensityDescription:'光源密度越高，场景精细度越高，所需成本也略高',
    high:'高',
    middle:'中',
    low:'低',
    delete:'删除',
    size:'尺寸',
    nameLengthLimit:'名称长度不能超过15个字符',
    nameRequired:'请填写名称',
    shuangluPoint: '实际点位数{{num}},与当前点位数量不匹配',
    oneKeyUpLevel:'一键升级',
    childDevice:'子设备',
    lightLibrary:'光效库',
    upImageTip:'提示：图片会根据设备尺寸自适应拉伸',
    customizeName:'自定义名称',
    configTip:'配置中,请稍后再试',
    unbindTips:'解绑方案后，将取消已关联的子设备，清空与该设备相关的场景、自动化，请确认是否继续？',
    reBuildTips:'重绘点位后, 清空与该设备相关的场景、自动化，请确认是否继续？',
    delTips:'设备删除后，将解绑所有关联的子设备，清空与该设备相关的场景、自动化，请确认是否继续？',
    delTips2:'删除的设备中,包含天幕设备,设备删除后,将解绑所有关联的子设备，清空与该设备相关的场景、自动化',
    channelCount:'回路数',
    pointCount:'点位数',
    addTianmuDevice:'添加天幕设备',
    guanlian:'关联',
    bindPlan:'绑定方案',
    bindDevice:'关联设备',
    bindPlanTitle:'请选择当前账号下的方案',
    bindDeviceTitle:'请选择需要关联的设备',
    bindDeviceWarning:'请选择需要关联的设备',
    shareWarning:'请输入接收人联系方式',
    shareWarning1:'请输入正确的手机号格式',
    shareWarning2:'请输入正确的邮箱格式',
    successMsg:'分享成功',
    shareTitle:'天幕设计方案分享',
    notice: '通知',
    sizeDesignNotAllowed:'尺寸无法设计',
    chooseOneOfTwo: '二选一',
    uploadVideo:'上传视频',
    videoSize:'MP4格式，大小150M以内，时长不超过1分钟',
    onlyMp4Format:'文件格式不支持',
    onlyVideoSize:'文件大小超过150M',
    onlyVideoTime:'文件时长超过1分钟',
    importVideo:'导入视频',
    upVideoTip:'视频会根据设备尺寸自适应拉伸',
    overflowTip:'场景已满,请删除后重试',
    sure: '确 定',
    configurationSchemeCannotDelete:'配置中的方案不能删除',
    maxScenesLimit:'最多只能下发5个视频场景',
    productModel: '产品型号',
    controllerType:'控制器类型',
    createStandard: '创建标品方案',
    standard: '标品方案',
    office: '办公楼',
    addDescription: '请添加描述',
    aiCreate: 'AI正在绘制中...',
    atUploading: '正在上传中...',
    historyList: '历史记录',
    uploadFailed: '加载失败，请重试',
    qualityLight: '品质光',
    UploadIorV: '上传视频/图片',
    aiCreateTip: '分享你的创意想法或有趣图片, 生成专属AI光效吧~',
    sceneDescription: '请输入光效描述，如：清晨的阳光、落日的余晖',
    myCreation: '我的创作',
    enterNow: '立即进入',
    newConversation: '新对话',
    aiCreating: 'AI正在生成中',
    aiFailed: 'AI生成失败',
    imageEditing: '图片编辑',
    generatedImage: '生成的图片',
    devicePreview: '设备预览',
    saveToMyCreations: '保存至我的创作',
    picHasSaved: '图片已保存至我的创作',
    creativeDescription: '请输入你的创意描述',
    sunsetGlow: '落日余晖',
    snowCcovered: '白雪皑皑',
    groupSpacing: '组间距',
    addArray: '添加阵列',
    arrayInfo: '阵列信息',
    arrayN: '阵列{n}',
    duplicateArrayLength: '长度 {length} 已存在，请选择其他长度',
    lineLightLength: '线型灯长度',
    arrayCount: '阵列数量',
    densityModalDesc: '光源密度越高，沿墙照度越高，所需成本也越高',
    implementationSpec: '实拍产品规格',
    highDensity: '高密度',
    middleDensity: '中密度',
    lowDensity: '低密度',
    radiusLessThanMaxLen: '半径必须大于阵列最大长度 {maxLen}m',
    radiusRequired: '半径不能为空，已根据阵列情况自动重置',
    circleArrayEmpty: '请添加阵列信息，点击「应用」进行点位预览',
    arrayRequired: '线型灯阵列信息不能为空',
    arrayFieldRequired: '线型灯长度或阵列数量不能为空',
    arrayApplyRequired: '请先点击「应用」生成点位预览',
    arrayLayoutInvalid: '阵列布局校验未通过，请调整后重试',
    wellSky: '天境',
    xidingDeng: '吸顶灯',
    canDiao: '餐吊灯',
  },
  sceneTemplate: {
    warningTemplateTextAuto1: '检查当前区域是否有灯具',
    warningTemplateTextAuto2: '检查当前区域是否有传感器或面板',
    warningTemplateTextAuto3: '如1,2满足,但仍无数据,表示当前行业暂无模板',
    picScene: '图片场景',
    titleFreePic: '限时免费',
    title: '欧普·场景模板',
    scheme: '场景模板',
    preView: '预览',
    sure: '确 定',
    finished: '执行完成',
    application: '应 用',
    noMatchedDevice: '没有匹配的设备',
    selfDefine: '自定义场景',
    templateDefine: '使用场景模板',
    warningText: '您选择的空间中暂无支持设备，请先添加设备或选择有设备的空间，再使用场景模板！',
    warningTemplateText: '您选择的空间中暂无场景模板！',
    autoTitle: '欧普·自动化模板',
    warningTextAuto: '当前房间内没有传感器或面板，请先添加再使用模板。',
    warningTemplateTextAuto: '您选择的空间中暂无模板。',
    lightTripDefine: '灯带展示场景',
    copyScene: '复制场景',
    tianmu: '天幕场景',
    sceneEffectPreview: '场景效果预览',
    selectImg: '请选择图片模板或自定义上传图片',
    imageTemplate: '图片模板',
    customUpload: '自定义上传',
    morning: '晨曦',
    silentNight: '静夜',
    blueSky: '蓝天白云',
    blueSkySun: '蓝天白云+太阳',
    holiday: '沐日',
    sunsetGlow: '晚霞',
    sunset: '夕照',
    risingSun: '旭日',
    noNeedPath: '当前圆形场景下无需绘制路径',
    needPath: '当前矩形场景下请先绘制路径再保存！',
    lightTripInputLampCount: '请输入每行灯片的个数，用英文“,”分隔，例如',
    createImageScenes: '创建图片场景',
    chooseDevice: '选择需要调节的设备',
    tianmu2: '天幕',
    blueSkyLamp: '蓝天灯',
    selectStyle: '选择样式',
    selectLampType: '选择灯具类型',
    select4: '请选择4个',
    lightingParameters: '灯具参数',
    lampMode: '灯具模式',
    selectColor: '颜色选择',
    limit: '3M以内的jpg/png格式图片',
    screenSplicing: '画面拼接',
    splicing: '拼接',
    noSplicing: '不拼接',
    originalImage: '原图',
    sdlColor: 'SDL颜色',
    lightTripOption: '灯带参数',
    shadowEffect: '窗影效果',
    clearSky: '晴空',
    dawn: '晨光',
    twilightGlow: '暮霞',
    blueSkyWhiteClouds: '蓝天白云',
    rainbowAfterRain: '雨后彩虹',
    spring: '春回大地',
    summerScenery: '夏日风情',
    cleanSweep: '秋风落叶',
    winter: '冬日飞雪',
    blueSkyA: '蓝天A',
    blueSkyB: '蓝天B',
    synthesis: '将多个灯具拼成1个画面',
    row: '行数',
    col: '列数',
    Round4in1: '圆形4合1',
    customSize: '自由尺寸',
  },
  devicecard: {
    deviceAndChanel: '设备及回路数',
    offline: '离线',
    online: '在线',
    callpolice: '报警',
    malfunction: '故障',
    lifeto: '寿命到',
    attributes: '属性',
    area: '区域',
    switchstatus: '开关状态',
    light: '亮度',
    colortemperature: '色温',
    illuminance: '照度',
    temperature: '温度',
    movement: '动静',
    humidity: '湿度',
    co2: '二氧化碳',
    pm: 'pm2.5',
    power: '功率',
    energyconsumption: '能耗',
    remaininglife: '剩余寿命',
    motortravel: '电机行程',
    electricity: '电量',
    motorangle: '电机角度',
    dataing: '数据同步中',
    identification: '识别',
    plank: '当前看板',
    selected: '已选',
    info: '操作提示',
    sameUnmoved: '相同区域无法移动',
    delDeviceInfo: '回路设备请去设备管理中进行删除操作',
    alreadycheck: '已选',
    nobind: '虚拟',
    dowarn: '操作提示',
    refresh: '刷新',
    ok: '确定',
    cancel: '取消',
    nonametip: '名称不能空',
    deviceTotal: '设备数',
    gatewayTotal: '网关及子设备数',
    identifNone: '此设备为低功耗设备，请参照产品说明书引导来识别。',
    identif1: '1.按下智能开关的重置（R）按钮一次（<1s）',
    identif2: '按1次人体传感器的复位按钮',
    identif3: '2.然后用户界面上对应的设备卡将闪烁三次，从而确认当前设备的识别成功。',
    noComma: '名称中含有非法字符“#,#”请删除后再提交',
  },
  sceneCard: {
    mode1: '下班模式',
    mode2: '上班模式',
    mode3: '休息模式',
    mode4: '清扫模式',
    mode5: '应急模式',
    mode0: '无模式',
    state: '状态：',
    block: '区域：',
    go: '执行',
    base: '基本信息',
    cao: '设备操作',
    add: '添加',
    type: '场景图标',
    name: '场景名称：',
    alreadydelete: '设备已删除',
    alreadymove: '设备被移动',
    save: '保存',
    back: '返回',
    unifiedcontrol: '统一控制',
    up: '上翻',
    down: '下翻',
    lightSwitch: '开关',
    colorWarm: '色温',
    color: '颜色',
    light: '亮度',
    openLight: '开灯',
    closeLight: '关灯',
    selected: '已选',
    configuration: '配置中',
    allsuccess: '全部成功',
    onesuccess: '部分成功',
    allfail: '全部失败',
    invalid: '无效',
    select: '勾选',
    all: '全选',
    clear: '全不选',
    sceneId: '场景ID：',
    joinYes: '使能',
    joinNo: '禁能',
    dim: '分级调光',
    dimmingDown: '调暗',
    dimmingUp: '调亮',
    cct: '分级调色温',
    cctWarm: '调暖',
    cctCold: '调冷',
    selectDevice: '选择设备',
    readReprot: '查看',
    expandDeviceList: '展开设备列表',
    allon: '全开',
    alloff: '全关',
    lightTripImg: '灯带场景信息',
    lightTripRankImg: '灯带排列图',
    lightTripCanvasInfo2: '选择一条灯带在中心编辑区内绘制灯带',
    lightTripCanvasInfo3: '绘制多条灯带时，尽量保持灯带之间的排布均',
    lightTripCanvasInfo4: '确保所有灯带都绘制在图形区域内',
    lightTripCanvasDraw: '绘制路径',
    lightTripCanvasEdit: '编辑路径',
    lightTripCanvasDelete: '删除路径',
    lightTripCanvasBack: '回撤路径',
    lightTripRightAngle: '直角模式',
    lightTripCanvasDrawInfo: '激活后，鼠标左击添加锚点，右击结束 本次绘制',
    lightTripCanvasEditInfo: '激活后，鼠标可拖动路径中的线段',
    lightTripCanvasDeleteInfo: '激活后，可删除当前选中的路径',
    lightTripCanvasBackInfo: '激活后，回撤一步路径',
    size: '尺寸',
    lightTripInputLampCount: '请输入灯珠数量',
    lightCount: '灯片数',
    line: '线',
    circle: '圆',
    senceWarning: '保存前，请将设备状态调整至与页面一致！',
    noEdit: "当前场景不支持编辑功能。",
    noCopy: "当前场景不支持复制功能。",
    workStatus: '工作状态',
    sceneNumber: '情景号',
    sensor: '感应',
    alwaysOpen: '常开',
    alwaysClose: '常关',
    sleep: '休眠',
    leastOne: '至少保留一个设备',
    noAvailableDevice: '没有可用设备',
  },
  install: {
    configTip: '配置提示',
    measuringDeviceTip1: '设备接入后，请按照如下步骤先去配置计量工具统计的区域及对象',
    measuringDeviceTip2: '在监控页面点击"参数配置"',
    measuringDeviceTip3: '在"能耗统计配置"中配置本设备的统计区域和对象',
    deviceHasAtRoom: '设备已在此房间',
    otaToolTip: 'BLE信号强度',
    otaTipTitle1: '以下设备需先升级到最新固件才可移动区域！',
    otaTipTitle11: '升级成功后:',
    otaTipTitle12: '1. 进入左侧 “安装 ”选项卡中的 “无区域”。',
    otaTipTitle13: '2. 在区域树/房间结构中向下滚动，点击 “无区域”。',
    otaTipTitle14: '3. 使用右上角的“操作”功能移动设备。',
    otaTipTitle15: '4. 选择设备并点击移动。',
    otaTipTitle2: '请去应用市场下载如下“欧普智能系统"APP',
    otaTipTitle3: '本设备建议升级到最新固件再移动区域！',
    otaTipTitleBatchAll:'以下#个设备需升级到最新固件！升级进度请前往升级任务查看。',
    otaTipTitleBatch:'升级成功后:',
    otaTipTitleBatch1:'1. 进入左侧 “安装 ”选项卡中的 “无区域”。',
    otaTipTitleBatch2:'2. 在区域树/房间结构中向下滚动，点击 “无区域”。',
    otaTipTitleBatch3:'3. 使用右上角的 “一键移动 ”移动设备，将标记房间的所有设备移动到目标房间。',
    otaTipTitleBatch4:'4. 或使用右上角的 “任务--移动 ”完成设备到目标房间的移动。',
    toWebTip: '去web升级',
    toAppbTip: '去App升级',
    continue: '继续',
    getInfo: '知道了',
    deviceType: '设备类型',
    protocol: '协议类型',
    typeAname: '输入名称或Mac地址',
    choose: '请选择',
    remveblock: '转移目标区域',
    finsh: '完成',
    devicecounterror: '请至少选择一个设备进行操作',
    areacounterror: '请至少选择一个区域进行移动',
    loading: '拼命加载中',
    noarea: '无区域',
    truegateway: '网关',
    truedevice: '设备',
    powerwarn: '请输入大于0的数字',
    slelectModifyNameCaption: '快捷选择-区域+设备类型',
    deviceFilter: '设备筛选',
    deviceStatus: '设备状态',
    duplicateAreatips: '执行复制操作前请先删除当前区域的场景和自动化',
    duplicateNativeTipInfo: '区域复制引导',
    duplicateNativeTipSelectAre: '选择区域',
    duplicateNativeTipBind: '设备对应情况',
    duplicateNativeTipMain: '复制内容',
    duplicateNativeInfo: '复制内容：场景、自动化、#设备参数（暂不支持）',
    duplicateNativeInfo1: '模板区域内设备必须与本区域内的设备有正确的对应关系，如下图所示',
    duplicateNativeInfo2: '复制所有相关设备都属于模板区域的场景与自动化',
    duplicateNativeInfo3: '需确保本区域内不含场景与自动化',
    duplicateNativeInfoConfirm: '以上条件已确认',
    duplicateStart: '开始复制',
    duplicateTargetArea: '本区域',
    duplicateSourceArea: '模板区域',
    duplicateArea: '复制区域',
    duplicateBindErrorTip: '目标区域内设备与模板区域内设备对应错误，无法进行下一步',
    duplicateBindRelaErrorTip: '设备映射关系不正确',
    duplicateInfo1: '本区域内有与模板区域内设备类型，设备名称，SKU，完全相同的设备，但数量多于模板区域，区域内场景与自动化可复制。',
    duplicateInfo2: '两个区域设备数量完全一致，设备类型，设备名称，SKU有任何一个不一致，区域内场景与自动化不可复制。',
    duplicateInfo3: '本区域内设备数量少于模板区域内设备，区域内场景与自动化不可复制。',
    duplicateInfo4: '可复制的模板区域的场景与自动化：因为仅包含本房间内的设备',
    duplicateInfo5: '不可复制的模板区域的场景与自动化：因为包含其他房间的设备',
    sceneNumberConfig: '情景号配置',
    sceneNumberCount: '情景号数量:',
    inputTip: '请输入内容',
    areaMapping: '区域映射配置',
    sceneConfig: '情景配置',
    duplicateAreaNumber: '存在重复的区号，请检查后再保存',
    doNotShowThisAgain: '不再显示',
    deviceAdded: '共#个设备已成功添加',
    addResult: '本次共添加#个设备，#个设备已移动到目标房间，以下#个设备请点击‘完成’前往无区域升级到最新固件，升级完成后可移动！如需继续添加设备请点击‘继续’。`',
    forceUpgrade: '强制升级',
    batchUpgrade: '一键升级',
    batchMove: '一键移动',
    moveOnlyMarked: '一键移动仅移动标记了目标区域的设备',
    noUpgradableDevices: '暂无可升级的设备',
    movableDevices: '暂无可移动的设备',
    overwriteTargetWarning: '设备已标记的目标区域将被覆盖，请确认是否继续？',
    targetArea: '目标区域',
    aiTokenFailed: '获取AI token失败',
  },
  deviceVirtual: {
    span: '添加虚拟设备',
    header: '请选择网关',
    nextstep: '下一步',
    wifitype: '选择网关',
    nolinewifi: '无线网关',
    devicetype: '设备类型',
    placeholderone: '请选择',
    placeholdertwo: '请输入设备名称',
    yes: '确定',
    addwifi: '添加网关',
    devicetypewarning: '请选择设备分类',
    wifitypewarning: '请选择网关',
    gatewayerror: '请先去添加网关',
    xylx: '请选择协议类型',
  },
  deviceMsg: {
    wait: '等待中...',
    resetRelayDevice: '复位继电器设备',
    lightMode1: '日光',
    lightMode2: '彩光',
    lightMode3: '白光',
    lightMode4: '纯彩',
    lightMode5: '音乐',
    area: '区域',
    basicinformation: '基本信息',
    devicename: '设备名称',
    devicetype: '类型',
    devicestatus: '设备状态',
    online: '在线',
    offline: '离线',
    agreementtype: '协议类型',
    mac: 'MAC地址',
    deviceclassification: 'SKU',
    deviceclassificationname: '设备分类名称',
    cloudid: '云ID',
    virtualid: '虚拟设备ID',
    createdtime: '创建时间',
    loopid: '回路ID',
    loopname: '回路名称',
    devicetypeid: '设备类型ID',
    more: '展开更多',
    collapse: '收起更多',
    deviceoperating: '设备操作',
    move: '移动',
    replace: '替换',
    delete: '删除',
    factorysetting: '恢复出厂设置',
    restart: '重启',
    stop: '停止',
    start: '启动',
    parameter: '配置参数',
    ota: 'OTA升级',
    currentversion: '当前版本',
    newversion: '最新版本',
    uptodate: '最新',
    advancedoptions: '高级选项',
    specificversion: '特定版本',
    upgrade: '升级中',
    pause: '暂停',
    issued: '正在下发OTA文件',
    initiatefail: '发起升级失败',
    ingfail: '升级失败',
    stopfail: '终止失败',
    stopsuccess: '终止成功',
    prompt: '提示',
    deletedeviceinfor: '此操作将删除该设备, 是否继续?',
    resetdeviceinfor: '此操作将恢复出厂设置, 是否继续?',
    restartdeviceinfor: '此操作将重启该设备, 是否继续?',
    replacedeviceinfor: '此操作将替换该设备, 是否继续?',
    calibratedeviceinfor: '此操作将校准该设备, 是否继续?',
    save: '确定',
    cancle: '取消',
    configsuccess: '成功',
    configing: '配置中',
    configfail: '失败',
    configdefault: '默认',
    hightOption: '高级选项',
    specificVersion: '特定版本',
    uppage: '上翻',
    downpage: '下翻',
    savesubmit: '保存',
    uplevel: '升级',
    waitForupgrade: '待升级',
    Upgradeing: '升级中',
    UpgradeSuccess: '成功',
    UpgradeDuplicate: '重复升',
    UpgradeFail: '失败',
    UpgradeConfilct: '操作冲突',
    UpgradeBusy: '网关忙碌中，请稍后再试',
    UpgradeProjectIdNull: '没有项目编号',
    parentdevicename: '父设备名称',
    calibrate: '校准',
    calibrateLUX: '校准照度',
    calibrateLUXButton: '重置',
    calibrateLUXTip: '校准照度',
    calibrateTemp: '校准温度',
    calibrateTempButton: '重置',
    calibrateTempTip: '校准温度',
    sure: '确定',
    calibrateBoxTip: '请输入当前桌面照度值',
    calibrateHistoryTip: '已录入照度值',
    calibrateAddItem: '添加一组',
    calibrateItemRealityTip: '当前实际照度值',
    calibrateItemInputTip: '当前测量照度值',
    calibrateItemWriteTip: '请输入测量照度值',
    calibrateItemLimitTip: '提示: 最多添加#条记录!',
    otaupdateBleTip: '升级是按组别进行的，所以耗时比较长',
    isActionPostTitle: '设备操作即时执行',
    calibrateTempBoxTip: '请输入当前桌面温度值',
    calibrateTempHistoryTip: '已录入温度值',
    calibrateTempItemRealityTip: '当前实际温度值',
    calibrateTempItemInputTip: '当前测量温度',
    calibrateTempItemWriteTip: '请输入测量温度值',
    gateWayBoard: '主板',
    gateWaySubCard: '子卡',
    morefirmwaretip: '以下固件都属于该设备，固件只能逐步升级。',
    morefirmwareview: '查看固件最新状态',
    canUpgradeingMaster: '可升级固件',
    firmwareNo: '固件序号',
    otabootTrue: '已确认以上操作',
    lengthLimit: '请输入 1-{{length}} 位字符',
    heating: '制热',
    refrigeration: '制冷',
    dehumidification: '除湿',
    airSupply: '送风',
    soundOff: '静音',
    LSpeed: '低速',
    MSpeed: '中速',
    HSpeed: '高速',
    auto: '自动',
    groupPlaceholder: '请输入{{$$RANG}}的邻组号',
    group: '组',
    area2: '区',
    groupTips: '最多添加8个邻组',
    colorCustomize: '自定义',
    cxCyEmpty: '请输入色坐标 Cx、Cy，格式为0.0000, 0.0000',
    cxCyFormatError: '请输入正确的色坐标格式，如 0.4527, 0.3937',
    cxCyOutOfRange: '色坐标超出可输入范围，请重新输入',
    validHexColor: '请输入合法的十六进制颜色值',
    rangeOfTheColorPalette: '输入色值超出色盘范围，已修正为色盘颜色',
    know: '我知道了',
    ciexy: '色坐标',
    noRelationDevice: '暂无关联设备',
    refreshing: '刷新中...',
    refreshFail: '刷新失败, 请重试',
    refreshSuccess: '刷新成功',
    pleaseSetWifi: '请先在参数配置中设置Wi-Fi',
    lengthLimit1: '文字长度控制在{Min}-{Max}',
    lengthLimit2: '密码长度控制在{Min}-{Max}',
    screenSetting: '屏幕设置',
    defaultScreen: '默认屏幕',
    maxScreenSettingTips: '最多支持{{MaxCount}}个',
    keySetting: '按键设置',
    keyInput: '请输入按键名称',
    unSetting: '未配置',
    secondDeleteConfirm: '与#name#及其子设备相关的场景和自动化将失效，是否确定删除？',
    option1: '选项1',
    option2: '选项2',
    changeBind: '更换',
    sureOk: '确认已完成以上流程',
    replaceMain: '替换主机',
    replaceSlave: '替换从机',
    goodness: '拟合度',
    excellent: '优秀',
    makeDo: '一般',
    poor: '不佳',
    tropic: '回归线',
    rawData: '原始数据',
    noOtaDevice: '该区域无可升级设备',
    recommendedValue: '推荐值',
    pleaseSelectDataType: '请选择数据类型：',
    lightAndPpfd: '光和光子通量密度（PPFD）',
    channelCountChanged: '通道数变动,请检查第{errorIndex}个控制器',
  },
  colorPicker: {
    gradient: '渐变色选择',
    gradientNum: '至少选择{{min}}个',
    gradientNum2: '不可多于{{max}}个'
  },
  deviceChoose: {
    choose: '设备选择',
    group: '生成群组',
    save: '保存',
    groupwarning: '请输入群组名称',
    sure: '确定',
    groupsingle: '群',
    checkwarning: '请至少选择一个设备',
    checkgroupwarning: '请勾选',
    devicestotal: '设备总数',
    overStepDeviceGroupTip: '呈现的设备不在同一区域,本群组将保存至指定区域',
    chooseDeviceInMap: '使用地图选择',
  },
  addScenes: {
    work: '上班',
    offwork: '下班',
    rest: '休息',
    sweep: '清扫',
    emergency: '应急',
    none: '无',
    scenenamewarning: '请输入场景名称',
    actionwarning: '请选择操作动作',
    select: '选择',
    isLightActionAutoOpareTip: '如果需要确保灯具会在场景中亮起，请使能开关和调光并且开关值为开',
  },
  ifttt: {
    searchPlhode1: '请输入自动化名称或关键字',
    iftttSetTemplate: '注意！当您已使用了恒照度自动化，想同时使用人感自动化，那您只能用“有人开灯（不指定亮度），无人关灯”人感自动化模板。',
    constillumsetTips: '已参与自动化调亮度的设备不能同时参与恒照度自动化',
    constillumset: '恒照度配置',
    aleadyset: '已配置',
    rhythmset: '日程配置',
    customize: '自定义配置',
    template: '办公室模板',
    clouddo: '云端执行',
    proximaldo: '近端执行',
    success: '全部成功',
    fail: '全部失败',
    ing: '配置中',
    custommode: '自定义配置',
    illuminationmodel: '恒照度',
    rhythmode: '日程',
    manual: '手动执行',
    status: '状态',
    time: '时间',
    delcounterror: '请至少选择一个',
    light: '恒照度配置',
    allset: '已配置',
    rhythm: '日程配置',
    templateName: '开发部门自动化集合',
    template2: '自定义模式',
    handle: '手动执行',
    templateName2: '开发部门自动化集合',
    rhythm00: '选择网关',
    rhythm01: '选择需要调节的灯具',
    lightTripOption: '设置灯带参数',
    lightTripSelect: '选择需要调节的灯带',
    lightTripLampCount: '请输入单条灯带灯珠数量',
    lightTripDirection: '请选择灯带排列方向',
    lightTripTransverse: '横向',
    lightTripVertical: '纵向',
    rhythm02: '设置日程',
    rhythmLine: '日程曲线',
    set: '自定义',
    lightDevice: '灯具',
    window: '窗帘',
    lightName: '亮度',
    colorName: '色温',
    addTime: '添加时间',
    openDegree: '开合度',
    Degree: '角度',
    info: '开合度：百叶窗的扇叶覆盖整体面积的比值;   角度：百叶窗的扇叶张开的角度。',
    save: '保存',
    upStep: '上一步',
    yes: '确定',
    sun: '亮度',
    light00: '选择网关',
    light01: '选择传感器',
    light02: '选择需要调节的灯具',
    light03: '阅读步骤说明',
    light04: '调节恒照度',
    requirement: '必要条件',
    requirement01: '校准传感器的照度值',
    requirement02: '确保安装时日光对传感器的影响不超过70%；',
    requirement03: '确保安装时无人干扰传感器和照度计的读数；',
    requirement04: '输入参考点校准后的照度值。',
    farmingRequirement01: '感光面水平朝上，远离立柱、喷头、灯下等遮挡溅水区域；',
    farmingRequirement02: '刚性支架固定，信号线与动力线分开，接头防水密封；',
    farmingRequirement03: '测点设于种植区中部，大面积分区域多点布置；',
    farmingRequirement04: '定期清洁感光罩，防止积污影响测量精度。',
    nextStep: '下一步',
    luxNum: '传感器照度值',
    watch01: '检查照度计读数',
    watch02: '请根据您的要求调整灯具亮度',
    address: '场所',
    standard: '照度标准值（lux）',
    timeSet: '调整设备不同时间段的属性',
    timeAdd: '至',
    timeStart: '开始时间',
    timeEnd: '结束时间',
    timePlaceholder: '选择时间范围',
    templateState: '状态',
    execute: '云端执行',
    baseMsg: '基本信息',
    tempateName: '名称：',
    iftttSet: '自动化设置',
    rangTime: '生效时间',
    day: '工作日 全天 长期有效',
    add: '添加',
    if: '如果',
    iftttPlaceholder: '请选择',
    timing: '定时',
    stating: '就执行',
    delayed: '延时',
    minute: '分',
    statingGo: '执行',
    back: '返回',
    week: '星期',
    weekpush: '除节假日 (勾选即排除节假日)',
    cancel: '取消',
    timingset: '定时设置',
    templateManger: '模板管理',
    templatetext: '模板',
    templateinfo: '如以上模式不满足您的需要，可自行添加!',
    addTemplate: '模式添加',
    closeRhythm: '关闭日程',
    addPanel: '添加面板',
    PanelInfo: '请添加面板后绑定面板按键！',
    dayPlaceholder: '选择日期时间',
    'trigger ': '触发对象',
    introduce: '说明介绍',
    scence: '场景',
    closeLight: '关闭所有灯',
    trigger: '触发对象',
    open: '开',
    close: '关',
    addressText1: '起居室（一般活动)',
    addressText2: '起居室（书写阅读）',
    addressText3: '餐厅',
    addressText4: '阅览室',
    addressText5: '普通办公室',
    addressText6: '超市营业厅',
    addressText7: '医院候诊室',
    addressText8: '学校教室',
    addressText9: '学校教室黑板',
    addressText10: '普通走廊、流动区域',
    addressText11: '机械加工粗加工',
    Illuminance: '照度',
    color: '颜色',
    zdy: '请去“自定义”页面设置窗帘的开合度和角度',
    zdylight: '请去“自定义”页面设置灯具的亮度,色温和照度',
    hourxh: '默认模式(24小时循环)',
    secondsxh: '演示模式(24秒循环)',
    warning1: '请至少选择一个设备',
    warning2: '请至少设置一个时间段操作',
    warning3: '选择的时间段有冲突',
    warning4: '选择的时间段避免有冲突',
    no: '编号',
    iftttSelect: '自动化选择',
    selectIFTTT: '请至少选择一个自动化',
    openSwitch: '开',
    closeSwitch: '关',
    del: '删除',
    selected: '已选',
    farGoing: '云端执行',
    nearGoing: '近端执行',
    timingDot: '定时：',
    sensorDot: '传感器：',
    rhythmtime: '时间',
    nowarn: '无法修改开闭环',
    groupControl: '群控',
    timeStarToEnd: '选择的时间段(结束时间大于等于开始时间)',
    selectGateway: '选择网关',
    groupControlTip: '选择群控后,当前所有设备和群组均不可选状态!',
    noFindGateWayTip: '无网关设备',
    luxCorrectNum: '传感器校准后照度值',
    constillumName: '恒照度名称',
    rhythmName: '日程名称',
    constillumNameTips: '请输入恒照度名称',
    rhythmNameTips: '请输入日程名称',
    rhythmSelectJoinModel: '选择参与配置',
    manualmode: '手动执行',
    panelmode: '面板触发',
    devicemode: '设备触发',
    schedulemode: '定时',
    nonemode: '无效',
    sensorCorrectionTips: '注意：传感器尚未校准，无法自定义目标照度',
    automationTotal: '自动化总数',
    iftttCustomSetPanel: '面板配置',
    iftttSelectPanel: '选择面板设备',
    iftttDefaultNoRealImg: '暂无面板实物示意图',
    automationRules: '自动化规则',
    configurationDetails: '配置详情',
    maxConfigMessage: '最多增加10个节点',
    maxConfigMessage30: '最多增加30个节点',
    configWarnMessage: '两点之间的时间应大于1小时',
    hclConfig: '节律配置',
    lightTripConfig: '灯带配置',
    templateConfig: '从模板添加',
    hcl: '节律',
    areacontrol: '区控',
    hclNameTips: '请输入节律名称',
    hclName: '节律名称',
    hcl02: '设置节律曲线',
    hclLine: '节律曲线',
    copyIfttt: '复制自动化',
    isLoadingData: '数据加载中 请稍等',
    notice: '通知',
    needOneClickConfiguration: '是否需要一键配置',
    oneClickConfiguration: '一键配置',
    elfInfo: '一键配置将自动配置“开关”“亮度”“色温/颜色”三个按键 的控制对象，智控与拍一拍，需在详情页配置',
    controlObject: '控制对象',
    wakePro: '请先点击设备上任意键或拍一拍 唤醒设备再点击保存',
    wakeProRetry: '请先点击设备上任意键或拍一拍 唤醒设备',
    aWakened: '已唤醒',
    associatedConfiguration: '关联配置',
    associatedInfo: '请添加“开关”“亮度”“色温/颜色”三个按键 控制的对象',
    associatedConditioning: '关联空调',
    addObject: '添加对象',
    noConfiguration: '暂无配置',
    buttonAutomation: '按键自动化配置',
    createUp3: '最多创建${{n}}条',
    selectObjects: '选择对象',
    intelligentControl: '智控（可配）',
    clickExecute: '单击执行',
    lightDetection: '灯光检测',
    clickDetect: '单击检测',
    switchFn1: '单击切换功能',
    switchFn2: '旋转调节数值',
    onOff: '单击开灯/关灯',
    rotate: '旋转',
    constantIlluminanceTip: '恒照度策略将灯具亮度调到最低时,关灯',
    chooseSame: '请选择同类设备',
    sureUseIfttt: '是否确认启用自动化',
    sureDisableIfttt: '是否确认禁用自动化',
    useIftttTip: '启用自动化后，当前区域的定时、日程、节律、恒照度、自动化将被启用',
    disableIftttTip: '禁用自动化后，当前区域的定时、日程、节律、恒照度、自动化将被禁用',
    needChangeGateway: '抱歉!,您的网关目前不支持“开关翻转配置，如需使用，请更换网关!',
    needUpdateGateway: '请先升级设备版本，才可使用开关翻转功能',
    sensorTemplate: '传感器模板',
    panelTemplate: '面板模板',
    scheduledSequence: '定时序列',
    loopSequence: '循环序列',
    actionItem: '执行项',
    pleaseAddOneActionItem: '请至少添加一项执行项',
    addScheduledSequenceItem: '添加定时序列项',
    sunriseSunset: '日出/日落',
    pleaseAddOneSequenceStep: '请至少添加一个定时序列步骤',
    eachStepNeedsActionItem: '每个定时序列步骤都至少需要添加一项执行项',
    absoluteTime: '绝对时间',
    relativeDelay: '相对延迟',
    effectiveCount: '生效次数',
    repeatLoop: '重复循环',
    customLoopCount: '自定义循环次数',
    times: '次',
    supportSunriseSunsetOffset: '支持设置日出/日落前/后 0~240 分钟',
    selectSunriseSunset: '选择日出/日落',
    associatedDateSettings: '关联日期设置',
    weekly: '每周',
    monthly: '每月',
    yearly: '每年',
    // 补光策略
    supplementalLighting: '补光策略',
    slTimeOverlapTip: '时段不可重叠，自然光区间单位：μmol/(m²·s)',
    slAddStrategy: '+ 新建策略',
    slEmptyStrategy: '暂无策略，点击「新建策略」开始配置',
    slStrategyName: '策略名称',
    slStrategyType: '策略类型',
    slLampSwitchStatus: '开关灯状态',
    slTargetBrightnessPpfd: '目标亮度 | PPFD',
    slTargetLightPpfd: '目标光强 (PPFD)',
    slIsEnabled: '是否启用',
    slNewStrategy: '新建策略',
    slEditStrategy: '编辑策略',
    slStrategyNameLabel: '策略名：',
    slStrategyCondition: '策略条件',
    slExecuteAction: '执行动作',
    slNaturalLightMin: '自然光下限：',
    slNaturalLightMax: '自然光上限：',
    slNaturalLightRangeError: '自然光下限须小于自然光上限',
    slDelayLightOn: '延迟开灯设置',
    slDelayLightOnTip: '开灯后亮度将从 0% 逐步递增至设定目标亮度；系统会依照填写的调节间隔时长与调节总次数，分多步进阶梯调光，直至亮度达到目标值',
    slAdjustInterval: '调节间隔：',
    slAdjustCount: '调节次数：',
    slTargetBrightness: '目标亮度：',
    slTargetLight: '目标光强：',
    slTimeOrderError: '开始时间与结束时间不能相同',
    slTimeOverlapError: '时段存在重叠，请调整后保存',
    slDelayAdjustDurationError: '调节间隔×(调节次数-1)不能大于策略时段时长',
    slCrossDay: '（跨天）',
    slApplying: '策略应用中…',
    slCreating: '创建中…',
    slSaving: '保存中…',
    slStrategyPrefix: '策略',
    slTypeStaticTimed: '静态补光（定时）',
    slTypeStaticNatural: '静态补光（定时+自然光）',
    slTypeDynamic: '动态补光',
    slAreaAnchor: '区域锚定值 (μmol/(m²·s))',
    slAreaAnchorTip: '灯具全开光强锚定值，用于将亮度百分比换算为实际补光 PPFD：实际补光 PPFD = 区域锚定值 × 当前灯具亮度百分比',
    slArtificialDli: '人工光 DLI (mol/(m²·d))：',
    slNaturalDli: '自然光 DLI (mol/(m²·d))：',
    slCumulativeDli: '累计光 DLI (mol/(m²·d))：',
    slTurnOffWhenMet: '满足条件时关灯',
    slTimelineCover: '24H 时段覆盖',
    slSelectAreaLeft: '请先在左侧选择区域',
    slCompleteStrategy: '请填写完整策略信息',
    slConfirmDelete: '确认删除该策略？',
    slDisabled: '停用',
  },
  iftttset: {
    noSimultaneously: '不能同时执行',
    rename: '重命名',
    isOccupied: '以下设备已被设置$$,无法使用群控功能',
    or: '或',
    Mon: '星期一',
    Tues: '星期二',
    Wed: '星期三',
    Thur: '星期四',
    Fri: '星期五',
    Sat: '星期六',
    Sun: '星期日',
    doifttt: '执行自动化',
    doswitchifttt: '开/关自动化',
    doscene: '执行场景',
    device: '设备',
    allcondition: '满足所有条件',
    onecondition: '满足任意条件',
    select: '选择条件',
    allday: '全天',
    long: '长期有效',
    noholiday: '除节假日',
    baseinfor: '基本信息',
    basename: '名称',
    automationset: '自动化设置',
    effectivetime: '生效时间',
    adddata: '添加',
    if: '如果',
    selectioncriteria: '选择条件',
    timing: '定时',
    handledo: '手动执行',
    do: '就执行',
    do1: '执行',
    delay: '延时',
    minutes: '分',
    scene: '场景',
    ifttt: '自动化',
    switchifttt: '开关自动化',
    save: '保存',
    back: '返回',
    week: '星期',
    time: '时间',
    to: '至',
    starttime: '开始时间',
    endtime: '结束时间',
    range: '选择时间范围',
    data: '日期',
    butholiday: '除节假日 (勾选即排除节假日)',
    sure: '确 定',
    cancle: '取 消',
    timingset: '定时设置',
    delayset: '延时设置',
    triggerset: '设备触发设置',
    actionset: 'Action设置',
    namewarning: '自动化名称不能为空',
    effectivetimewarning: '请设置生效时间',
    conditions: '请选择满足条件',
    triggerwarning: 'trigger不通过',
    actionwarning: 'action不通过',
    weekwarning: '请至少选择一个星期',
    handlewarning: '手动执行无法删除',
    nodoiftttwarning: '无法执行自动化',
    onehandlewarning: '只能添一个手动执行',
    deldevicewarning: '请先删除定时跟设备',
    candohandlewarning: '无法手动执行',
    delhandlewarning: '请先删除手动执行',
    tommrow: '次日',
    upmove: '上移',
    downmove: '下移',
    up: '上翻',
    down: '下翻',
    and: '至',
    hour: '时',
    off: 'OFF模式',
    on: 'ON模式',
    add: '新增',
    minus: '- 模式',
    colormode: '色温+ 模式',
    colorAddmode: '色温+ 模式',
    colorMinusmode: '色温- 模式',
    closeMode: '关闭其他模式',
    openMode: '打开其他模式',
    key1: '按键1',
    key2: '按键2',
    key3: '按键3',
    key4: '按键4',
    key5: '按键5',
    key6: '按键6',
    key7: '按键7',
    key8: '按键8',
    keyOn: '按键ON',
    keyOff: '按键OFF',
    keyAdd: '按键+',
    keyMinus: '按键-',
    officeMode: '会议模式1',
    speechMode1: '演讲模式1',
    speechMode2: '演讲模式2',
    officeTemplate: '办公室模板',
    chooseTemplate: '请选择模板',
    choose: '请选择',
    enterTemplateName: '请输入模板名称',
    havePeople: '有人',
    noPeople: '无人',
    illumination: '恒照度',
    rhythm: '日程',
    second: '秒',
    officeAutomation: '办公室集合自动化',
    SelectDelayTime: '请选择延时时间',
    SelecTtriggle: '请至少选择一个触发能力',
    SelecAction: '请至少选择一个执行能力',
    SelecTime: '请选择时间',
    haveTime: '时间已存在',
    setTiming: '只能设置一个定时',
    setSun: '只能设置一个日出日落',
    timeOrSunExclusive: '定时和日出日落只能存在其一',
    pleaseAddOneDelayItem: '请至少添加一项延时',
    lux: '照度（lux）',
    times: '时间(s)',
    dataStep: '数据同步',
    ok: '确定',
    cancel: '取消',
    info: '提示',
    delIllumination: '确定删除恒照度?',
    delRhythm: '确定删除日程?',
    IlluminationDevice: '照度设备',
    developAutomation: '开发部门自动化集合',
    deviceMove: '动静传感器',
    deviceMove1: '动静传感器',
    alreadydelete: '已删除',
    alreadymove: '被移动',
    repeat: '重复',
    every: '每天',
    wordDay: '工作日',
    weekEnd: '周末',
    customize: '自定义',
    weekTip: '请选择重复周期',
    timeTip: '请选择开始至结束时间',
    dataTip: '请选择开始至结束日期',
    along: '长期',
    triggershowtotaltip: '提示: 最多添加#16#条自动化条件',
    actionshowtotaltip: '提示: 最多添加#32#条执行操作',
    triggerandactiontip: '提示：自动化条件最多添加#16#条，实现操作最多添加#32#条， 请合理删除过多的内容！',
    areacontrol: '区域控制',
    SelecArea: '请至少选择一个区域',
    hcl: 'HCL',
    templateList: '模板自动化列表',
    holidays: '节假日',
    notHolidays: '非节假日',
    executeOnlyOnce: '仅执行一次',
    executionMode: '执行方式',
    moreSettings: '更多设置',
    local: '本地',
    cloud: '云端',
    recommendation: '推荐',
    tip1: '断网状态也可使用本地执行',
    tip2: '无法通过本地执行场景时,可尝试切换至云端执行',
    ifttt3Tip: '以下设备不支持#节假日#功能，请调整',
    ifttt3Tip2: '以下设备支持#节假日#功能，请调整',
    delayedToggleAutomationSwitchState: '延迟翻转自动化开关状态',
    automaticalTurnOnOff: '在#2秒#后自动#关闭#',
    automationSettings: '自动化设置',
    toggleSettings: '开关切换设置',
    notConfigured: '未配置节假日，请先去项目详情配置节假日',
    permissionDenied:'（检测到您无该权限，请先联系该项目管理员开通权限）',
    areaName: '房间名',
    gotoConfig:'去配置',
    sunrise: '日出',
    sunset: '日落',
    dateRange: '日期范围',
    timingSequenceAction: '定时序列的动作',
    timeSetting: '时间设置',
    pleaseInputConstantLightIntensityName: '请输入恒光强名称',
    noSupportTip: '网关或设备版本太低,请先升级',
  },
  lastLight: {
    Illuminance: '照度',
    open: '开环',
    close: '闭环',
    lessthan: '小于',
    brightness: '亮度',
    range: '范围',
    to: '至',
    big: '大于',
    standard: '场所照度标准参照表',
    warning: '注意：请等待传感器读数稳定之后,点击确认按钮',
    selectwaring: '请选择传感器',
    must: '请选择至少一个设备',
    selectwaring2: '请选择调节的设备',
    selectwaring3: '照度值需大于0',
    selectwaring4: '小于值错误',
    selectwaring5: '区间范围错误',
    selectwaring6: '大于值错误',
  },
  otatask: {
    firmware: '固件',
    mainFirmware: '主固件',
    childFirmware: '子固件',
    latest: '最新',
    upgrading: '升级中',
    taskCreateAllName: '所有设备升级',
    areaname: '区域',
    canUpgradeingDevice: '可升级设备',
    canUpgradeingDevice2: '可创建升级任务的设备',
    initiatefail: '发起升级失败',
    warninginfor: '暂无可升级设备',
    waitForupgrade: '等待升级',
    UpgradeChecking: '校验中',
    Upgradeing: '正在升级',
    UpgradeSuccess: '升级成功',
    taskSuccess: '成功',
    UpgradePartSuccess: '升级部分成功',
    UpgradeDuplicate: '重复升级',
    UpgradeFail: '升级失败',
    taskFail: '失败',
    UpgradeConfilct: '操作冲突',
    UpgradeBusy: '网关忙碌中，请稍后再试',
    UpgradeProjectIdNull: '没有项目编号',
    UpgradePasue: '升级暂停',
    info: '操作提示',
    stopfail: '终止失败',
    stopsuccess: '终止成功',
    createTime: '创建时间',
    startTime: '开始时间',
    lastTime: '完成时间',
    userId: '创建者',
    bysku: '按设备类型',
    byarea: '按区域',
    devicetype: '设备类型',
    selectedsku: '已选设备类型',
    selecteddevice: '已选设备',
    resumeOperate: '取消选择',
    taskname: '任务名称',
    taskjuststart: '立即执行',
    taskCustom: '定时执行',
    createUpgradeTask: '创建升级任务',
    createUpgradeTaskTimeTip: '此升级任务过程大概需要#分钟，结果可至升级任务列表查看',
    taskNameTip: '请填写任务名称',
    finishcontinuecreate: '完成并继续创建',
    taskDeleteTip: '你确定要把这#个任务删除吗？',
    Unicast: '单设备升级',
    byprojectUpgradeStart: '全部升级',
    selected: '已选',
    tasktitlesku: '类型',
    tasktitledevice: '设备',
    UpgradeStop: '终止升级',
    taskStop: '取消升级',
    nostopupdatetip: '所选择的待升级设备中含有升级开始就不可终止的设备，即正在升级的任务取消升级后，此类设备也将继续完成升级！',
    oparenosametip: '当前所选的任务状态不一致，无法统一批量操作',
    taskStoppingTip: '取消升级中',
    taskid: '任务ID',
  },
  qrcode: {
    projectsettitle: '项目地址位置未确定！',
    projectsettip: '二维码创建需要项目明确的位置来进行设置围栏权限。',
    projectsetok: '进行设置',
    projectsetcancel: '暂不设置',
    switchtitle: '确认关闭二维码访问权限吗？',
    switchtip: '二维码访问权限关闭后，通过此二维码分享的用户将不再能访问此项目的该区域，正在访问的用户也会强制退出！',
    deltitle: '确认删除二维码吗？',
    deltip: '二维码删除后，区域访问权限将关闭，正在访问的用户也会强制退出，相关信息也将全部删除！',
    qrcodetitle: '区域权限管理',
    switch: '分享开关',
    sharearea: '分享区域',
    qrcodename: '二维码名称',
    qrcodenametip: '二维码名称不能为空',
    screenroatetip: '为了更好的体验，请将手机/平板竖过来',
    intoloading: '正在加载二维码控制中心',
    device: '设备',
    areacontrol: '区控',
    scene: '场景',
    positionsearchtip: '请输入搜索地址',
    position: '定位',
    latlon: '经纬',
    latitude: '纬度',
    longitude: '经度',
    ableActionTip: '分享者已关闭访问权限，您将被强制退出， 如有问题，请联系管理员！',
    ableTokenTip: '使用权限已经失效，如有问题，请联系管理员！',
    gpsOpen: '定位已打开',
    gpsOpenTip: '访问项目想要获取您的位置信息，请打开定位，并且允许浏览器使用位置信息.<br><br>\n        <b>尝试以下操作:</b><br>\n        1、请打开手机定位服务，并且允许浏览器使用位置信息<br>\n        2、浏览器【位置】设置里，允许所有网站访问位置信息',
    locationserices: '定位服务',
    whileappuse: '使用APP期间',
    beyondPositionTip: '<h>当前所在位置距离较远，无法访问!</h><br>\n        <b>请在扫码区域附近尝试以下操作:</b><br>\n        1、请打开手机定位服务，并且允许浏览器使用位置信息<br>\n        2、浏览器【位置】设置里，允许所有网站访问位置信息',
    changearea: '切换区域',
    mapnoadresstip: '未找到相关地址！',
    createqrcode: '生成二维码',
    createqrcodetips: '二维码可通过智能手机扫描后控制智能照明系统；请注意，出于安全原因，只有当您在项目位置 2 公里范围内时，才可以通过此二维码控制照明系统。 因此，您需要打开手机的 GPS 定位，并且必须允许网页使用。',
    isWXAppTips: '请在默认浏览器中打开',
    pulldownrefresh: '下拉刷新',
    releaseupdate: '松开更新',
    updating: '更新中',
    loading: '加载中...',
    startingGPSpositioning: 'GPS定位启动...',
    GPSPositioningInProgress: 'GPS定位中...',
    accuracy: '准确度',
    altitude: '海拔',
    altitudeAccuracy: '海拔准确度',
    heading: '行进方向',
    groundSpeed: '地面速度',
    GPSPositioningFailed: 'GPS定位失败',
    startingBDPositioning: 'BD定位启动....',
    BDPositioningInProgress: 'BD定位中...',
    BDPositioningDataReturned: 'BD定位数据返回....',
    BDPpositioning: 'BD定位',
    BDPositioningFailed: 'BD定位失败',
    BDPositioningStartupFailed: 'BD定位启动失败',
  },
  home: {
    changeProfessional: '切换专业版本成功',
    changeNotProfessional: '切换普通版本成功',
    zoomScaleTip: '浏览器或系统处于缩放状态，页面可能会出现错位现象，建议100%缩放',
    onlineTipsHeaderTitle: '掉线了?',
    onlineTipsDescribe: '请确认网络是否连接,否则会造成当前工作丢失!',
    onlineTipsOKtext: '好的, 我知道了',
    allArea: '全部区域',
    allProject: '所有项目',
    ruiyi: '睿壹',
    ouxiangjia: '欧享家',
    collectTop: '收藏项目置顶',
    collectOnly: '仅显示收藏项目',
  },
  base: {
    notice: '公告',
    sure: '确定',
    back: '返回',
    cancel: '取消',
    deltext: '删除不可恢复，是否确定删除？',
    more: '更多',
    delete: '删除',
    transfer: '移交',
    move: '移动',
    download: '下载',
    export: '导出',
    import: '导入',
    type: '类型',
    state: '状态',
    all: '全部',
    total: '数量',
    upStep: '上一步',
    nextStep: '下一步',
    name: '名称',
    selectall: '全选',
    latestedVersion: '最新版本',
    localVersion: '当前版本',
    restart: '重试',
    start: '启动',
    pasue: '暂停',
    refresh: '刷新',
    create: '创建',
    searchKey: '搜索关键字',
    searchByState: '按状态筛选',
    searchByCreateTime: '按任务创建时间',
    operate: '操作',
    resetFilter: '重置筛选',
    to: '至',
    startdate: '开始日期',
    enddate: '结束日期',
    lastWeek: '最近一周',
    lastMonth: '最近一月',
    lastThreeMonths: '最近三个月',
    details: '查看详情',
    startingTip: '启动中',
    restartingTip: '重试中',
    errorcode: '错误码',
    search: '搜索',
    succeed: '成功',
    error: '失败',
    group: '群组',
    applyFor: '申请',
    noEmpty: '不能为空',
    bind: '绑定',
    unbind: '解绑',
    redraw: '重绘点位',
    mobilephonenumber: '手机号码',
    smsverificatoncode: '短信验证码',
    sendverificatoncode: '发送验证码',
    sendagain: '重新发送',
    write: '输入',
    finish: '完成',
    spread: '展开',
    modify: '编辑',
    notip: '下次不再提醒',
    detail: '详情',
    save: '保存',
    yes: '是',
    no: '否',
    skip: '跳过',
    updateTitle: '更新说明',
    helpCenter: '帮助中心',
    before: '前',
    after: '后',
  },
  visual: {
    pdfTransFail: 'pdf转换失败',
    sizeMaxFile: `文件尺寸最大$$1px*$$2px`,
    maxFile: '文件最大$$mb',
    lightRate: '亮灯率',
    areaRank: '区域排名',
    areaChoose: '选中区域',
    searchDevicePlaceholder: '请输入设备名称搜索',
    deviceDetail: '设备详情',
    childDeviceRelation: '子设备拓扑',
    drawRoom: '绘制房间',
    drawArea: '绘制区域',
    pic: '图片',
    maxNumPic: '最多上传10张图片',
    maxSizePic: '图片尺寸不能大于5000*5000px',
    deviceNeedTime: '设备还未全部加载完成',
    lowEnergy: '低能耗',
    highEnergy: '高能耗',
    upImgAndLook: '当前区域下暂无图纸，请先按如下步骤添加图纸和相关配置，再查看',
    initConfigTip1: '当前区域暂无图纸，请先按照步骤添加图纸',
    initConfigTip2: `1,  支持.jpg，.jpeg and .png图片格式且大小不超过$$1MB，小于$$2px * $$3px。`,
    initConfigTip3: `2, 支持.pdf格式，大小不限`,
    regionFrom: '所属地区',
    isSetNetwork: '是否配网',
    moreTitle: '更多状态及设备操作',
    deviceMore: '点击查看',
    bindagin: '重新绑定',
    bindingDiologTxt: '仅删除区域：',
    bindingDiologTxt1: '仅删除区域框，设备图标保留',
    bindingDiologTxt2: '全部删除：',
    bindingDiologTxt3: '删除区域以及区域内的设备图标',
    bindingDiologBtnTxt: '仅删除区域框',
    bindingDiologBtnTxt1: '全部删除',
    rightBind: '右击绑定房间',
    monitorUploadImg: '该区域尚未配置图纸 请先去配置图纸',
    toUpload: '去上传',
    currentArea: '当前区域',
    enableIfttt: '启用自动化',
    disableIfttt: '禁用自动化',
    enableIftttDialogTitle: '以下类型的自动化将被启用，其他自动化不受影响！',
    disableIftttDialogTitle: '以下类型的自动化将被禁用，其他自动化不受影响！',
    useDeviceDailog: '使用设备列表选择',
    chooseDeviceInMap: '使用地图选择',
    cancleAllSelect: '取消所有选择',
    selectSameDevice: '选择同SKU设备',
    chooseSKU: '请选择SKU',
    deleteConfirmTxt: '删除区域后，区域内原有设备将自动移除',
    rebindConfirmTxt: '重新绑定区域，区域内原有设备将自动移除',
    deviceTypes: '请选择设备协议类型',
    deleteEquipmentTip1: '仅删除区域：仅删除区域框，设备图标保留<br />全部删除：删除区域以及区域内的设备图标',
    deleteEquipmentTip2: '仅删除区域框',
    deleteEquipmentTip3: '全部删除',
    please: '请',
    deviceRepeat: '设备已存在',
    deviceInSelectRoom: '设备需放入选中房间内',
    device: '设备',
    selectRoom: '请选中地图的区域：##',
    deviceListMsg: '标记区域绑定完成后，设备可拖到标记区域定位',
    batchMobile: '批量移动',
    delAreaMsg: '您需要先将标记区域内的设备全部移除后才能重新绑定，确定去移除设备吗？',
    modify: '图纸配置',
    mapBg: '底图',
    roomTips: '房间标签',
    deviceTips: '设备标签',
    replace: '替换底图',
    del: '删除',
    identification: '识别',
    bindArea: '绑定区域',
    placeBind: '请先绑定',
    closeLight: '关闭',
    uploadImg: '上传图片',
    imgSize: '图片尺寸',
    lessThen: '且小于',
    uploading: '正在上传图片，请稍等',
    complete: '完成',
    bindAreaSet: '绑定区域设置',
    areaPlan: '区域平面图',
    areaIsBound: '该房间已被其他标记区域绑定，请先解绑后再操作！',
    areaDoNotBind: '区域不可绑定',
    clickInCanvas: '请尝试点住拖拽此设备至平面图中',
    imgType: '支持jpg、jpeg、png格式，最大尺寸为5MB',
    noImgType: '该类型文件不支持',
    noImgSize: '文件过大',
    planarModel: '平面图模式',
    edtAreaMsg: '区域内含有设备，请先将设备移除后再进行编辑',
    mapIsLoading: '加载中...',
    selectDevice: '选择设备',
    scence: '场景',
    ifttt: '自动化',
    ok: '确定',
    cancel: '取消',
    addScene: '新增',
    chooseDeviceGroup: '选择设备组',
    uifiedControl: '楼层统一控制',
    width: '宽度',
    height: '高度',
    editBg: '画板大小',
    notice: '提示',
    sureDelScene: '是否确认删除',
    sureDelGroup: '是否确认删除',
    delBg: '删除背景',
    noName: '欧普灯具',
    virtualDevice: '虚拟设备',
    virtualLibrary: '设备库',
    areaname: '区域',
    realDevice: '已配网设备',
    floorname: '楼层',
    virtualPoint: '虚拟点位',
    rect: '矩形区域',
    pencil: '不规则区域',
    opacity: '透明度',
    bgColor: '黑/白底',
    virtualTips: '拖拽标签至地图中生成设计点位',
    searchKey: '请输入设备名称',
    select: '选择并拖动',
    zoomScale: '缩放比例',
    Legend: '图例',
    connectDevice: '已配网设备',
    backDevice: '退出设备库',
    hasMac: '已扫码设备',
    lightBox: '标准项目-光盒子',
    batchBind: '批量绑定',
    batchNetwork: '批量配网',
    oneKeyConfig: '一键下发配置',
    other: '其他',
    downloadPoint: '下载点位表',
    createStandardProject: '创建标准项目',
    noNetwork: '未配网',
    toUpgrade: '去升级',
    upgradeTip: '以下设备版本不符合要求，请先升级后再尝试下发',
    upgradeTip2: '部分配置下发失败，请先检查设备是否上电，如无问题请点击“更换设备”，重新填写MAC地址后再次下发！',
    changeDevice: '更换设备',
    sendScene: '场景下发',
    sendingScene: '场景下发中',
    sendSceneSuccess: '场景下发完毕',
    sendSceneFail: '场景部分失败',
    sendIfttt: '自动化下发',
    sendingIfttt: '自动化下发中',
    sendIftttSuccess: '自动化下发完毕',
    sendIftttFail: '自动化部分失败',
    sendProgram: '节目单下发',
    sendingProgram: '节目单下发中',
    sendProgramSuccess: '节目单下发完毕',
    sendProgramFail: '节目单部分失败',
    noBind: '未绑定',
    macError: 'MAC地址错误',
    uploadPoint: '上传点位表',
    pointName: '点位名称',
    remark: '备注',
    next: '下一步',
    networked: '已配网',
    addressNotFilled: '地址未填写',
    addressRepeat: '地址重复请重新填写',
    waitNetwork: '等待设备入网, 请耐心等候, 约 1-3 分钟...',
    continueNetwork: '继续配网',
    waitNetwork2: '等待设备入网',
    gatewayNetwork: '光盒子网关 配网中',
    deviceRepeatBind: '设备不能重复绑定',
    networkFail: '配网失败, 稍后再试',
    gateway: '光盒子网关',
    networking: '配网中',
    networkFail2: '配网失败,请更换MAC地址后继续',
    networkFail3: '网关版本需要升级，请先升级后再配网',
    networkFail4: '请点击设备“Operation”按钮 倒计时',
    networkFail5: '网关添加成功, 软重启中约28秒, 请稍后...',
    networkFail6: '以下设备配网失败，请检查设备是否上电，如无问题请更换设备，重新填写MAC地址后再点击“继续配网”',
    refreshDevice: '刷新设备列表',
    pointNameTip: '指定点位名称',
    networkState: '配网状态',
    bindDeviceTip: '已绑定{BindDeviceCount}个设备，{NotBindPointCount}个点位未绑定，还剩{NotBindDeviceCount}个设备未绑定，请绑定对应的点位和设备',
    networkFailTip: '配网失败, 稍后再试',
    goToMonitor: '跳转监控地图',
    goToInstallation: '跳转安装地图',
    themeChange: '切换主题',
    exit: '退出',
    duplicateMAC: '同一个点位存在重复的设备',
    removeDevice: '请勿将设备移出房间',
    moveIntoTheRoom: '移入房间中',
    topLeft: '左上角',
    topRight: '右上角',
    Center: '中间',
    bottomLeft: '左下角',
    bottomRight: '右下角',
    deviceClustering: '设备聚合'
  },
  sortSelect: {
    type1: '按名称A-Z排序',
    type2: '按名称Z-A排序',
    type3: '按添加时间升序',
    type4: '按添加时间降序',
  },
  hcl: {
    deviceHcl: '设备所属节律',
    chartAllData: '显示所有节点数据',
    saveTemplate: '保存到自定义模板',
    oppleTemplate: '欧普·节律模板',
    template: '自定义节律模板',
    choose: '选择',
    hclType: '选择节律类型',
    argumentType: '选择参数类型',
    gradient: '渐变型',
    jump: '跳变型',
    lightCCT: '亮度+色温',
    onlyLight: '仅亮度',
    onlyCCT: '仅色温',
    whichHcl: '该设备已参与以下节律配置',
    CantHcl: '该设备暂不支持节律配置',
    warning: '提示：当前列表中包含 不支持节律的设备，无法使用区控功能',
    warning1: '请先在OTA中升级',
    enable: '启用',
    unable: '禁用',
    state: '状态',
    time: '时间',
    number: '编号：',
    enabled: '启用成功',
    unabled: '已禁用',
    perform: '近端执行',
    useTemplate: '应用',
    office: '办公室',
    school: '学校',
    factory: '工厂',
    naturalLight: '自然光',
    keywords: '请输入关键字',
    addTime: '添加时间',
    allHcl: '亮度+色温节律',
    lightHcl: '亮度节律',
    CCTHcl: '色温节律',
    hclState: '节律状态',
    tips: '提示',
    warning2: '1、当拖动并改变色温值时，该设备所属节律的色温节律将被打断，亮度节律将继续执行。 <br />2、当拖动并改变亮度值时，该设备所属节律的亮度节律将被打断，色温节律将继续执行。 <br />3、当拖动并该改变色温及亮度值时，该设备所属节律将关闭。<br />4、区控HCL 设备界面无法打断',
    HclConfig: '节律配置',
    warning3: '添加点：双击图表任意位置',
    warning4: '移动点：拖拽点可改变位置',
    warning5: '删除点：单击选中点可删除',
    warning6: '两点之间的时间应大于1分钟',
    close: '关闭',
    search: '搜索',
    introduce: '说明',
    type: '类型',
    del: '删除',
    all: '全选',
    cancle: '取消',
    add: '添加',
    set: '节点详情',
    colorName: '色温',
    cardLightCCT: '色温亮度运行中',
    cardLight: '亮度运行中',
    cardCCT: '色温运行中',
    cardStop: '已停止',
    editPoint: '编辑点',
    modify: '编辑',
    clear: '全不选',
    warning7: '设备选择数量超过20个时建议勾选区控',
    warning8: '请填写模板名称',
  },
  identify: {
    identify_default: 'Use \\"identify\\" to localize device',
  },
  reset: {
    reset_00010900_step_1: '1、上电网关\n2、插入网线：该网线需要可以访问Internet；该网口可以被DHCP分配地址\n3、如果需要，通过DA+/DA-连接DALI设备，不需要额外的DALI总线电源',
    reset_00010900_step_1_title: '有线网关安装',
    reset_00010900_step_1_check: '已上电联网',
    reset_00010900_step_2: '1、按住网关正面的‘‘操作’’按钮10秒以上\n2、如图所示绿色状态指示灯快速闪烁，网关进入重启状态\n',
    reset_00010900_step_2_title: '网关复位',
    reset_00010900_step_2_check: '网关已复位',
    reset_00010900_step_3: '1、如果以太网指示灯不亮，请检查网线到路由器的连接是否正常或者是否需要配置静态IP， 如果使用的是静态IP地址，请按住指示完成设置\n2、如果云指示灯不亮，请检查路由器是否可以访问Internet\n3、 如果状态指示灯为橙色，表示软件故障，请返回上一步再次尝试。假如依然不能解决，请联系网关提供商\n4、 如果状态指示灯为红色，表示硬件故障，请联系网关提供商；\n',
    reset_00010900_step_3_title: '检查网关状态',
    reset_00010900_step_3_check: '指示灯全部亮起且为绿色',
    reset_00010900_step_4: '输入网关设备上的MAC地址，或者直接扫描设备上二维码生成MAC地址',
    reset_00010900_step_4_title: '输入MAC地址',
    reset_00010900_step_5: '请单击设备“确认”按钮，并在确认后120s内点击页面“下一步”按钮',
    reset_00010900_step_5_title: '确认网关',
    reset_00010900_step_5_check: '已确认识别设备',
  },
  energyBoard: {
    noMeasuringDevice: '该项目暂无计量设备，请添加计量设备之后，再进入该配置项',
    energyFixedConfig: '能耗定额配置',
    carbonEmission: '碳排放因子配置',
    carbonFactor: '碳排放因子',
    country: '国家',
    inputByCountry: '当前国家暂未配置碳排放因子，请手动输入',
    inputCarbonFactor: '手动输入',
    inputManualSelection: '手动选择',
    inputNumber: '请输入数字',
    configTips: '请确保所选区域下所有设备都已接入该区域所绑定的计量工具',
    energyAndcarbonEmissionsConfig: '能耗定额/碳排放配置',
    measureDevice: '计量设备',
    deviceArea: '设备所在区域',
    deviceStatistics: '设备统计区域',
    timeClickTip: '单击日期选择开始时间，再次点击选择结束时间',
    HVAC: '暖通空调',
    powerConsumption: '动力用电',
    otherConsumption: '其他用电',
    showByDay: '按天显示',
    showByWeek: '按周显示',
    showByMonth: '按月显示',
    showByQuarter: '按季显示',
    showByYear: '按年显示',
    countrySet: '项目所属国家',
    carbonEmissionSet: '碳排放因子配置',
    YOYcurentMonth: '上月',
    energyType: '对比类型',
    addareaname: '添加区域',
    editareaname: '切换区域',
    energyCompare: '能耗对比',
    energyProportion: '能耗占比',
    energyTime: '统计时间',
    season: '季',
    energyConfig: '参数配置',
    energyConfigTips: '当前参数配置完成后统计生效',
    statistiMonthly: '按月统计',
    statistiQuarterly: '按季统计',
    statistiYear: '按年统计',
    configTime: '定额配置时间',
    configFinish: '配置完成',
    carbonEmissions: '碳排放量',
    lightEnergy: '照明用电',
    maxEnergy: '最高能耗',
    minEnergy: '最低能耗',
    averageEnergy: '平均能耗',
    maxEnergySavingRate: '最高节能率',
    minEnergySavingRate: '最低节能率',
    averageEnergySavingRate: '平均节能率',
    maxCarbonEmissions: '最高碳排放',
    minCarbonEmissions: '最低碳排放',
    averageCarbonEmissions: '平均碳排放',
    energy: '能耗',
    energyDesign: '设计能耗',
    energyDesign1: '设计能耗',
    energySave: '节约能耗',
    energySaveToytal:'节约能耗',
    actualEnergy: '实际能耗',
    energyBalanceCounting: '能耗余额倒计',
    unit: '单位',
    energyUnit: '能耗单位',
    carbonEmissionsUnit: '碳排放单位',
    currentMonth: '本月',
    currentYear: '本年',
    currentSeason: '本季度',
    energyRate: '能耗占比',
    energyComparison: '能耗对比',
    remainingEnergy: '能耗余额',
    energySavingRate: '节能率',
    remainingCarbonEmissions: '碳排放余额',
    carbonFootprint: '碳足迹',
    sequentialData: '环比',
    year_to_yearData: '同比',
    graph: '图形',
    table: '表格',
    exportTable: '导出报表',
    regionTips: '最多可选3个区域对比',
    region: '区域选择',
    statistiObject: '统计对象',
    statisticalIndex: '统计指标',
    energyStatistics: '能耗统计',
    quota: '定额量',
    statistiArea: '统计区域',
    energyQuota: '能耗定额',
    carbonEmissionsQuota: '碳排放定额',
    carbonEmissionsAll: '总碳排放量',
    energyAll: '总能耗',
    carbonBalanceCounting: '碳排放余额倒计',
    actualCarbonEmissions: '实际碳排放',
    year_to_year: '同比',
    curentDay: '当日',
    curentWeek: '当周',
    curentMonth: '当月',
    curentYear: '当年',
    curentSeason: '当季',
    YOYcurentDay: '上日',
    YOYcurentYear: '上年',
    YOYcurentSeason: '上季',
    staticSum: '指标统计',
    areaComparation: '区域同比/环比',
    areaProportion: '区域占比',
    max: '最高',
    min: '最低',
    onlineTotal: '在线/总数',
    openTotal: '开灯/灯具总数',
    existSensor: '存在照度传感器',
    config: '配置',
    statistiObjectConfig: '计量设备配置',
    other: '其他',
    pieEnergyListHeader: '区域实际能耗占比排行榜',
    pieEnergyListDes: '条形图展示的是所选区域在所选的时间范围内的实际能耗占比排行榜',
    pieEnergyHeader: '区域实际能耗占比',
    pieEnergyDes: '饼图展示的是所选区域在所选的时间范围内的实际能耗占比',
    statisticsNodule: '统计模块',
    selectStatisticalArea: '请选择统计区域',
    selectStatisticalModule: '请选择统计模块',
    exportFailed: '导出失败',
    sensorData: '传感器数据',
    prohibitCrossAreaSelection: '禁止跨区域选择',
    exportConfigTip1: '设备概况及故障统计仅能导出实时数据',
    exportConfigTip2: '传感器和空间利用率仅能导出最近一年的数据',
    exportConfigTip3: '(设备总数、在线数、离线、故障及分类数据)',
    exportConfigTip4: '(动静、温度、湿度、照度)',
    exportConfigTip5: '(指标统计、区域同比/环比、区域占比)',
    exportConfigTip6: '能耗占比统计默认为下级所有区域的占比',
    selectDateRangeTip: '选择的日期范围不能超过5年',
    selectDateRangeTip1: '选择的日期范围不能超过90天',
    selectDateRangeTip2: '选择的日期范围不能超过12个月',
    problemFeedback: '问题反馈',
    questionDescribe: '问题描述',
    describeTip1: '请详细描述您所遇到的问题或者给出的建议意见',
    describeTip2: '请输入设备SKU(8个字符)',
    describeTip3: '请输入您的手机号码或邮箱',
    describeTip4: '请输入正确的手机号或者邮箱',
    describeTip5: '请填写完整信息',
    describeTip6: '上传有效压缩包',
    describeTip7: '请输入设备MAC地址',
    describeTip8: '请输入您的姓名',
    deviceInfo: '设备信息',
    startTime: '问题起止时间',
    userInfo: ' 用户信息',
    userName: '姓名',
    userPhone: '联系方式',
    sureSubmit: ' 确定提交',
    firstEnergy:'灯具改造节能量',
    secondEnergy:'控制策略节能量',

    secondEnergyRate:'智能节能率',
    firstEnergyRate:'改造节能率',

    firstEnergyV2:'改造节能(率)',
    secondEnergyV2:'智能节能(率)',

    energyMode:'能耗统计模式',
    designEnergyConsumption:'设计能耗全量统计',
    rulesDes:'规则说明',
    rulesOpenDes:'工作时间段内，设计能耗按所有灯具*额定功率计算；非工作时间段内，设计能耗按开启灯具*额定功率计算。',
    rulesCloseDes:'全时段内设计能耗 = 开启灯具*额定功率计算*开灯小时数',
    rulesOpenDes1: '设计能耗 = 工作时间段内设计能耗 + 非工作时间段内设计能耗',
    rulesOpenDes2: '工作时间段内设计能耗 = 所有灯具*额定功率计算',
    rulesOpenDes3: '非工作时间段内设计能耗 = 开启灯具*额定功率计算',
    open:'开启',
    closed:'关闭',
    infoFrom:'信息来源：国家信息来源于“项目详情”-“国家信息”-“所属国家”',
    infoFrom1:'信息来源：',
    infoFrom2:'“项目详情”-“国家信息”-“所属国家”',
    city:'城市',
    building:'大楼',
    floor:'楼层',
    room:'房间',
    selectAreaType: '已选${{n}}组',

    tip1:'数据逻辑关系说明：',
    tip2:'设计能耗=实际能耗+节约能耗；',
    tip3:'节约能耗=一次节能+二次节能；',
    tip4:'平均节能率=节约能耗/设计能耗',
    tip5:'智能节能率=（改造后设计能耗-改造后的实际能耗）/改造后设计能耗 ',
    tip6:'改造节能率=（改造前设计能耗-改造后设计能耗）/改造前设计能耗',
    noPermissionContactOwner: '您暂无权限修改设置，请联系项目创建者开启该功能',
  },
  recycle: {
    dataRecovery: '数据恢复',
    sceneAutomationDeleteTips: '场景和自动化删除前会显示天数，之后将永久删除',
    restore: '恢复',
    deviceCannotBeEmpty: '设备不能为空, 无法恢复该条数据',
    relatedDeviceDeleted: '相关设备已删除，无法恢复',
    triggerActionCannotBeEmpty: '触发动作不能为空, 无法恢复该条数据',
    executionActionCannotBeEmpty: '执行动作不能为空, 无法恢复该条数据',
    day:'天'
  },
  notices: {
    noticeTimes: '通知频次设置',
    timeInterval: '时间间隔',
    timeCount1: '15分钟',
    timeCount2: '30分钟',
    timeCount3: '1小时',
    timeCount4: '12小时',
    timeCount5: '24小时',
    timeInterval_title1: '立即通知',
    timeInterval_title2: '按设备每小时通知',
    timeInterval_title3: '按时间通知',
    timeInterval_title4: '关闭通知',
    timeInterval_description1: '设备状态改变，就触发通知',
    timeInterval_description2: '无论该设备满足多少次触发条件，每个设备在1小时内只通知一次',
    timeInterval_description3: '在所设置的时间间隔内，无论多少个设备满足触发条件，只通知1次',
    timeInterval_description4: '满足触发条件后，不通知',
    subscription_name: '订阅名称',
    subscription_type: '订阅类型',
    sensor_alarm: '传感器告警',
    addSpecifiedDevice: '添加指定设备',
    triggerConditions: '触发条件',
    meetAllSensors: '满足所有传感器',
    satisfyAnySensor: '满足任意传感器',
    alarmConfiguration: '告警配置',
    notificationObject: '通知对象',
    auth: '权限',
    notifSelf: '默认通知本人',
    specifyUser: '指定用户',
    pushUser: '推送用户',
    method: '通知方式',
    subscriptionCenter: '订阅中心',
    allSubscriptions: '所有订阅',
    addSubscription: '新增订阅',
    all: '所有',
    noticeList: '若想编辑或取消该条通知请联系以下任意一个账户',
    know: '我知道了',
    checkDelete: '是否确认删除？此操作不可撤回！',
    deleteSuccess: '删除成功',
    watchAll: '查看所有消息',
    messageCenter: '消息中心',
    sendDate: '发送日期',
    ownProject: '所属项目',
    messageDetails: '消息详情',
    processedMan: '处理人',
    isHandle: '是否处理',
    processed: '已处理',
    notProcessed: '未处理',
    clickHandler: '点击处理',
    checkHandler: '是否确认已处理？此操作不可撤回！',
    readAll: '标记全部已读',
    processedSuccess: '处理成功',
    selectDate: '选择日期',
    markAsProcessed: '标记为已处理',
    readed: '已读',
    unRead: '未读',
    project: '项目',
    systemNotifications: '系统通知',
    emailNotifications: '邮件通知',
    messageNotifications: '短信通知',
    appPush: 'App通知推送',
    sensor: '传感器',
    processingTime: '处理时间',
    envAlarm: '环境类',
    areaAlarm: '区域类',
    envAlarmTip: '(使用传感器上报的数据作为触发条件，当环境变化满足设定的条件时推送告警或通知)',
    areaAlarmTip: '(定时推送指定区域相关的系统数据)',
    noticeByDay: '每日推送',
    noticeByWeek: '每周推送',
    noticeByMonth: '每月推送',
    pushTime: '推送时间',
    noticeByDayDescription: '(每日推送一次，推送昨日数据)',
    noticeByWeekDescription: '(每日推送时间，推送上周数据)',
    noticeByMonthDescription: '(每日推送时间，推送上月数据)',
    eachMonday: '每周一',
    eachTuesday: '每周二',
    eachWednesday: '每周三',
    eachThursday: '每周四',
    eachFriday: '每周五',
    eachSaturday: '每周六',
    eachSunday: '每周日',
    pushContent: '推送内容',
    temperature: '温湿度',
    faultProportion: '故障占比',
    thirdPartyAccount: '第三方个人账号',
    thirdPartyGroupAccount: '第三方群账号',
    batchImport: '批量导入',
    downloadImportTemplate: '下载导入模板',
    oppleUser: '欧普用户',
    thirdParty: '第三方用户',
    personalAccount: '请输入个人账号',
    groupAccount: '请输入群账号',
    oppleUserAccount: 'OPPLE用户',
    thirdPartyPersonalAccount: '第三方个人用户',
    thirdPartyGroup: '第三方群',
    deviceTotal: '设备总数、在线数、离线数据',
    energyStatistics: '实际能耗、节约能耗、节能率',
    areaTemperature: '区域温度、湿度数据',
    areaFaultProportion: '区域内故障设备占比数据(同APP-故障设备详情)',
    addAccount: '添加账号',
    batchDelete: '批量删除',
    importTemplate: '导入模板',
    areaCodeError: '区号重复',
    messagePush: '消息推送',
    pushMethod: '推送方式',
    pushApp: '向手机app推送',
    timeStamp: '时间标签',
    Day: '第',
  },
  icp: {
    company: '苏州欧普照明有限公司版权所有',
    icpNo: '苏ICP备13004515号',
    networkSecurity: '苏公网安备 32050902100527号',
  },
  networkCheck: {
    networkCheck: '网络检测',
    selectArea: '选择检测区域',
    cloudServer: '云服务器',
    normalSubDevice: '正常',
    abnormalSubDevice: '丢包设备',
    offlineSubDevices: '离线',
    weakSignal: '信号弱',
    linkNotWorking: '通讯不通',
    signalDifferenceEquipment: '高丢包率设备',
    offlineDevice: '离线设备',
    unableGateway: '无法完成联动的网关',
    reset: '重置',
    others: '直连设备',
    affectedIfttt: '受影响的自动化',
    affectedIftttTip: '自动化下网关位于不同局域网或不同网段,网络无法互通,导致通信异常。',
    serverCloud: '云服务器',
    signalStrength: '信号强度',
    communicationRate: '通信成功率',
    noGateway: '无网关设备',
    notCompatible: '与云链接不通',
    test: '检测',
    communicationTimes: '通讯状态',
    concatIt: '联系 IT',
    deviceList: '设备列表',
    completed: '全部完成',
    DetectionTool: '检测小工具',
    correspondingGateway: '对应网关',
    networkSegment: '网段',
    waitingToStart: '等待开始',
    onlyWin: '仅支持windows系统',
    toolsTip: '使用下列工具,可检测当前局域网是否允许访问欧普云所需的域名及端口',
    smallTool: '辅助小工具',
    localAreaNetwork: '可联系IT调整网络，确保让对应网关在一个局域网中',
    status1: '等待中',
    status2: '检测中',
    status3: '检测已完成',
    abnormalCause: '异常原因',
    solution: '解决方案',
    normalCommunication: '调整网络配置，确保自动化系统下的网关处于同一局域网环境，以恢复正常通信。',
    judgmentCriteria: '判定标准',
    poorCommunication: '当前设备信号不佳, 通信成功率不足$$%',
    indicatorDiagram: '指示灯图解',
    threeIndicators: '如下三个指示灯, 系统指示灯(1), 局域网指示灯(2), 云端连接指示灯(3)',
    troubleshootingSteps: '排查步骤',
    step1_v1: '1. 若三个指示灯都不亮,可能是供电异常或系统故障, 检查供电情况或更换硬件',
    step2_v1: '2. 若局域网指示灯(2)亮, 云端连接指示灯(3)闪烁, 访问外网正常但连接欧普云异常, 检查本地域名和端口限制，确保欧普使用的域名和端口不受限制',
    domainLabel: '域名:',
    portLabel: '端口:',
    step3_v1: '3. 若局域网指示灯(2)亮，云端连接指示灯(3)不亮，网关无法访问外网，检查本地网络限制',
    step4_v1: '4. 若局域网指示灯(2)不亮，网关无法获取IP，需检查网线连接是否异常、是否对网关DHCP限制、使用静态IP时是否正确配置网关IP',
    fourIndicators: '如下四个指示灯, 电源指示灯(1), 系统指示灯(2), 局域网指示灯(3), 云端连接指示灯(4)',
    step1_v2: '1. 若电源指示灯(1)不亮, 可能是供电异常, 请检查供电情况',
    step2_v2: '2. 若系统指示灯(2)、局域网指示灯(3)、云端连接指示灯(4)都不亮，可能是系统故障, 请更换硬件',
    step3_v2: '3. 若局域网指示灯亮(3)，云端连接指示灯(4)闪烁， 访问外网正常但连接欧普云异常，检查本地域名和端口限制，确保欧普使用的域名和端口不受限制。',
    officialDomain: '国内正式云域名(根据项目判断域名,欧洲为iotctrl1): ',
    step4_v2: '4. 若局域网指示灯(3)亮，云端连接指示灯(4)不亮，网关无法访问外网，检查本地网络限制',
    step5_v2: '5. 若局域网指示灯(3)不亮,则网关无法获取IP,需检查网线连接是否异常、是否对网关DHCP限制、使用静态IP时是否正确配置网关IP',
    fourIndicators_v3: '如下四个指示灯, 系统指示灯(1), 局域网指示灯(2), 云端连接指示灯(3), wifi指示灯(4)',
    step1_v3: '1. 若四个指示灯都不亮,可能是供电异常或系统故障, 检查供电情况或更换硬件',
    wifiStatusDesc: '5. Wi-Fi 指示灯(4)状态说明:',
    wifiOff: '指示灯不亮：表示 Wi-Fi 功能未启用。',
    wifiRedFlash: '红色闪烁：表示 Wi-Fi 已启用，但尚未配置 SSID。',
    wifiRedOn: '红色常亮：表示设备正在连接接入点（AP）。',
    wifiGreenFlash: '绿色闪烁：表示已成功连接接入点（AP），但尚未获取 IP 地址。',
    wifiGreenOn: '绿色常亮：表示已成功连接接入点（AP），并已获取有效 IP 地址，网络连接正常。',
    issueType: '问题类型',
    correspondingGateway2: '对应网关',
    crossNetwork: '跨网段',
    crossGateway: '跨网关'
  },
  controlArea: {
    bindRoomError1: '旋钮与部分灯具（{names}）不在同一网关，暂不支持调光，建议将它们移至同一网关。',
    bindRoomError2: '旋钮与该房间所有灯具均不在同一网关，无法控制，建议连接至同一网关。',
    bindRoomError3: '该房间无可控灯具，建议将旋钮移至有灯的房间或重新选择。',
    reSelect: '重新选择',
    knew: '知道了',
  },
  ...Locale,
}
export default zh
